/* tslint:disable */

declare namespace Agriport.Excel.Factory.InputData {
	interface IITableHeader {
		HeaderLabels: string[];
	}
	interface IIWorksheetPrintable {
	}
}
declare namespace Agriport.Excel.Factory.InputData.FieldDiary {
	interface IContent extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable ,Agriport.Excel.Factory.InputData.IITableHeader {
		HeaderLabels: string[];
		Rows: Agriport.Excel.Factory.InputData.FieldDiary.IContentRow[];
	}
	interface IContentRow {
		Amount1: string;
		Amount2: string;
		Amount3: string;
		Application1: string;
		Application2: string;
		Application3: string;
		Day: Date;
		Driver: string;
		Duration: System.ITimeSpan;
		FieldArea: number;
		FieldName: string;
		From: System.ITimeSpan;
		FuelTotal: number;
		GrossArea: number;
		GrossPerformance: number;
		InstrumentName: string;
		MachineName: string;
		NetArea: number;
		NetPerformance: number;
		NumberPart: number;
		Standstill: System.ITimeSpan;
		To: System.ITimeSpan;
		Unit1: string;
		Unit2: string;
		Unit3: string;
		Worktype: string;
	}
	interface IHeader extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Croptype: string;
		CroptypeLabel: string;
		FieldLabel: string;
		FieldNames: string[];
		From: Date;
		TimePointLabel: string;
		To: Date;
		Worktype: string;
		WorktypeLabel: string;
	}
	interface IReportData extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Content: Agriport.Excel.Factory.InputData.FieldDiary.IContent;
		Footer: Agriport.Excel.Factory.InputData.FieldDiary.ISummary;
		Header: Agriport.Excel.Factory.InputData.FieldDiary.IHeader;
	}
	interface ISummary extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		FieldTime: System.ITimeSpan;
		FieldTimeFuel: number;
		FieldTimeLabel: string;
		FuelLabel: string;
		StandstillLabel: string;
		StandstillTime: System.ITimeSpan;
		StandstillTimeFuel: number;
		SummaryLabel: string;
		SummaryTime: System.ITimeSpan;
		SummaryTimeFuel: number;
		TimeLabel: string;
	}
}
declare namespace Agriport.Excel.Factory.InputData.FungiDetect {
	interface IContent extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable ,Agriport.Excel.Factory.InputData.IITableHeader {
		HeaderLabels: string[];
		Rows: Agriport.Excel.Factory.InputData.FungiDetect.IContentRow[];
	}
	interface IContentRow {
		Attribute: string;
		Average: number;
		Date: Date;
		FieldArea: number;
		FieldName: string;
		Max: number;
		Min: number;
		NumberPart: string;
		Source: string;
	}
	interface IHeader extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Attribute: string;
		Average: string;
		Date: string;
		FieldArea: string;
		FieldName: string;
		FieldNumber: string;
		Max: string;
		Min: string;
		Source: string;
	}
	interface IReportData extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Content: Agriport.Excel.Factory.InputData.FungiDetect.IContent;
		Header: Agriport.Excel.Factory.InputData.FungiDetect.IHeader;
	}
}
declare namespace Agriport.Excel.Factory.InputData.NRestriction {
	interface IContent extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable ,Agriport.Excel.Factory.InputData.IITableHeader {
		HeaderLabels: string[];
		Rows: Agriport.Excel.Factory.InputData.NRestriction.IContentRow[];
	}
	interface IContentRow {
		AlreadyApplied: string;
		Area: string;
		Balance: string;
		MainCropExpectedYield: string;
		MainCropType: string;
		MaxAllowance: string;
		Name: string;
		Number: string;
		Remaining: string;
		Removal: string;
		SubNumber: string;
	}
	interface IHeader extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		AlreadyApplied: string;
		Area: string;
		Balance: string;
		MainCropExpectedYield: string;
		MainCropType: string;
		MaxAllowance: string;
		Name: string;
		Number: string;
		Remaining: string;
		Removal: string;
		SubNumber: string;
	}
	interface IReportData extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Content: Agriport.Excel.Factory.InputData.NRestriction.IContent;
		Header: Agriport.Excel.Factory.InputData.NRestriction.IHeader;
	}
}
declare namespace Agriport.Excel.Factory.InputData.PerformanceReport {
	interface IContent extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable ,Agriport.Excel.Factory.InputData.IITableHeader {
		HeaderLabels: string[];
		Rows: Agriport.Excel.Factory.InputData.PerformanceReport.IContentRow[];
	}
	interface IContentRow {
		Action: string;
		AvgEnginePower: number;
		AvgEngineTorque: number;
		AvgSpeed: number;
		Day: Date;
		Driver: string;
		Duration: System.ITimeSpan;
		FieldName: string;
		From: System.ITimeSpan;
		FuelTotal: number;
		Instrument: string;
		MachineName: string;
		To: System.ITimeSpan;
		Way: number;
		Worktype: string;
	}
	interface IHeader extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Actions: string[];
		ActionsLabel: string;
		Croptype: string;
		CroptypeLabel: string;
		Driver: string;
		DriverLabel: string;
		FieldLabel: string;
		FieldNames: string[];
		From: Date;
		InstrumentLabel: string;
		InstrumentName: string;
		MachineLabel: string;
		MachineName: string;
		TimePointLabel: string;
		To: Date;
		Worktype: string;
		WorktypeLabel: string;
	}
	interface IReportData extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Content: Agriport.Excel.Factory.InputData.PerformanceReport.IContent;
		Header: Agriport.Excel.Factory.InputData.PerformanceReport.IHeader;
	}
}
declare namespace Agriport.Excel.Factory.InputData.SoilSampleField {
	interface IContent extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable ,Agriport.Excel.Factory.InputData.IITableHeader {
		HeaderLabels: string[];
		Rows: Agriport.Excel.Factory.InputData.SoilSampleField.IContentRow[];
	}
	interface IContentRow {
		ClassK: string;
		ClassMg: string;
		ClassP: string;
		ClassPh: string;
		Date: Date;
		FieldArea: number;
		FieldName: string;
		K: number;
		Mg: number;
		NumberPart: number;
		P: number;
		Ph: number;
		SoilGroups: string;
	}
	interface IHeader extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		ClassK: string;
		ClassMg: string;
		ClassP: string;
		ClassPh: string;
		Date: string;
		FieldArea: string;
		FieldName: string;
		K: string;
		Mg: string;
		NumberPart: string;
		P: string;
		Ph: string;
		SoilGroups: string;
	}
	interface IReportData extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Content: Agriport.Excel.Factory.InputData.SoilSampleField.IContent;
		Header: Agriport.Excel.Factory.InputData.SoilSampleField.IHeader;
	}
}
declare namespace Agriport.Excel.Factory.InputData.SoilSamplePlanningReport {
	interface IContent extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable ,Agriport.Excel.Factory.InputData.IITableHeader {
		HeaderLabels: string[];
		Rows: Agriport.Excel.Factory.InputData.SoilSamplePlanningReport.IContentRow[];
	}
	interface IContentRow {
		CropType: string;
		CropTypeMinus1: string;
		CropTypePlus1: string;
		CropTypePlus2: string;
		Description: string;
		FieldArea: number;
		FieldName: string;
		FieldNumber: number;
		FieldSubNumber: number;
		GridSize: number;
		LandUse: string;
		LastSampleDate: string;
		NextSampleDate: string;
		OrganicApplication: string;
		PlannedScan: boolean;
		SampleAmount: number;
	}
	interface IHeader extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		CropType: string;
		CropTypeMinus1: string;
		CropTypePlus1: string;
		CropTypePlus2: string;
		Description: string;
		FieldArea: string;
		FieldName: string;
		FieldNumber: string;
		FieldSubNumber: string;
		GridSize: string;
		LandUse: string;
		LastSampleDate: string;
		NextSampleDate: string;
		OrganicApplication: string;
		PlannedScan: string;
		SampleAmount: string;
	}
	interface IReportData extends Agriport.Excel.Factory.InputData.IIWorksheetPrintable {
		Content: Agriport.Excel.Factory.InputData.SoilSamplePlanningReport.IContent;
		Header: Agriport.Excel.Factory.InputData.SoilSamplePlanningReport.IHeader;
	}
}
declare namespace Agriport.Invoker.Api.Database {
	export const enum DatabaseNotifyOperation {
		Insert = 0,
		Update = 1,
		Delete = 2
	}
}
declare namespace Agriport.Invoker.Api.SessionHandling {
	interface IAgriportSession {
		Age: System.ITimeSpan;
		AgeTotal: System.ITimeSpan;
		BrowserTabId: string;
		CampaignYear: number;
		ClientIp: string;
		ConnectionId: string;
		CreatedAt: Date;
		CurrentModule: string;
		DurationHours: number;
		EditGeometries: boolean;
		FarmId: number;
		IsDeprecated: boolean;
		IsOutdated: boolean;
		Language: string;
		ListenChanges: boolean;
		UpdatedAt: Date;
		UserId: number;
	}
}
declare namespace Data.AccessPermission {
	interface IAccessPermissions extends Data.Api.IBaseEntity {
		Farmname: string;
		Feature_Id: number;
		Feature_Key: string;
		Feature_Translationkey: string;
		Featuremodul_Description: string;
		Featuremodul_Id: number;
		Featuremodul_Key: string;
		Featuremodul_Translationkey: string;
		Groups: Data.AccessPermission.IGroupMapping[];
		Id: number;
	}
	interface IGroupMapping {
		access_permission: boolean;
		farm_id: number;
		farmname: string;
		feature_description: string;
		feature_id: number;
		feature_key: string;
		feature_translationkey: string;
		featuremodul_description: string;
		featuremodul_id: number;
		featuremodul_key: string;
		featuremodul_translationkey: string;
		usergroup_id: number;
		usergroup_name: string;
	}
	interface IUsergroup {
		Farm_Id: number;
		Group: Data.AccessPermission.IUsergroupsGroup;
		Group_Id: number;
		Id: number;
		Name: string;
	}
	interface IUsergroupFeature {
		Farm_Id: number;
		Feature: Data.Licensing.IFeature;
		Feature_Id: number;
		Id: number;
		Usergroup: Data.AccessPermission.IUsergroup;
		Usergroups_Id: number;
	}
	interface IUsergroupsGroup {
		Id: number;
		Key: string;
	}
	interface IUsergroupUser {
		FarmUserId: System.IGuid;
		Id: System.IGuid;
		Usergroup: Data.AccessPermission.IUsergroup;
		Usergroup_Id: number;
	}
}
declare namespace Data.Agronomic {
	interface IApplicationRateSlope {
		EcMax: number;
		EcMin: number;
		EppoGroup: Data.Agronomic.IEppoGroup;
		Id: System.IGuid;
		Slope: number;
	}
	interface IApplicationSettings {
		EcMax: number;
		EcMin: number;
		EppoGroup: Data.Agronomic.IEppoGroup;
		Id: System.IGuid;
		OperationMode: Data.Common.IOperationMode;
		Parameter: Data.Agronomic.IApplicationSettingsParameters;
		TranslationKey: string;
	}
	interface IApplicationSettingsParameters {
		deadBioMass: number;
		max: number;
		min: number;
		recommendation: number;
		slope: Data.Agronomic.ISlopeConfiguration[];
		slopeShown: boolean;
		slopeType: string;
		targetValue: number;
		uniform: number;
	}
	interface IEppoGroup {
		Description: string;
		EppoCodes: string[];
		Id: System.IGuid;
	}
	interface IMonitoringRules {
		CountryGroup: Data.Common.ICountryGroup;
		EcMax: number;
		EcMin: number;
		EppoCode: string;
		Id: System.IGuid;
		MonitoringType: Data.Fields.IMonitoringType;
		Rule: Data.Agronomic.IRuleDefinition;
	}
	interface IRuleDefinition {
		Id: number;
		ImplClass: string;
	}
	interface ISlopeConfiguration {
		Id: number;
		Key: string;
		Slope: number;
	}
}
declare namespace Data.Api {
	interface IBaseEntity extends Data.Api.Validation.IApDataAnnotationsValidate {
		ChangedAt: Date;
		ChangedBy: number;
		CreatedAt: Date;
		CreatedBy: number;
		DeletedAt: Date;
		DeletedBy: number;
		FarmId: number;
		Version: number;
	}
}
declare namespace Data.Api.Validation {
	export const enum ApValidationLevel {
		Info = 0,
		Warning = 1,
		Error = 2,
		Success = 3,
		News = 4
	}
	interface IApDataAnnotationsValidate {
	}
	interface IApValidationResult {
		Counter: number;
		DisplayTimeout: number;
		ErrorKey: string;
		Level: Data.Api.Validation.ApValidationLevel;
		Parameters: string[];
		UserId: number;
		UserName: string;
	}
}
declare namespace Data.Authentication {
	interface IActiveUser {
		CampaignYear: number;
		ClientIp: string;
		CreatedAt: Date;
		CurrentModule: string;
		FarmId: number;
		IsOutdated: boolean;
		UpdatedAt: Date;
		User: Data.Authentication.IUser;
	}
	interface ICampaignYear {
		CopiedFields: number[];
		DefaultEnd: Date;
		DefaultStart: Date;
		FarmId: number;
		FieldCount: number;
		Id: number;
		MaxInitialNeedK: number;
		MaxInitialNeedMg: number;
		MaxInitialNeedP: number;
		MaxInitialNeedPh: number;
		Year: number;
	}
	interface IFarm {
		Country: Data.Common.ICountry;
		CustomerNumber: string;
		ErpId: number;
		FarmExtent: string;
		FarmName: string;
		Id: number;
		Location: string;
		Message: string;
		PostalCode: string;
		RegistryNumber: string;
		Sourcestatus: number;
		State: string;
		Status: number;
		Street: string;
		Street2: string;
		StreetNo: string;
		Town: string;
		ZipCode: string;
		ZoomPosition: number;
	}
	interface IFarmMatch {
		Checksum: string;
		DateFrom: Date;
		DateTo: Date;
		FarmId: number;
		FarmSchemaDocu: string;
		HasDocuFarm: boolean;
		HH_FarmId: number;
		HH_UserName: string;
		Id: number;
		LastRun: Date;
		LoadDate: Date;
		LoadInterval: number;
		LoadType: number;
		WagesBusinessManId: number;
	}
	interface IFarmUsers {
		BranchOfActivityId: number;
		Driver: Data.DocuContext.Driver.IDriver;
		Farm: Data.Authentication.IFarm;
		FarmId: number;
		Id: System.IGuid;
		IsActive: boolean;
		IsDriver: boolean;
		User: Data.Authentication.IUser;
		UsergroupUser: Data.AccessPermission.IUsergroupUser[];
		UserId: number;
	}
	interface IFarmUsersBase {
		BranchOfActivityId: number;
		Farm: Data.Authentication.IFarm;
		FarmId: number;
		Id: System.IGuid;
		IsActive: boolean;
		User: Data.Authentication.IUser;
		UserId: number;
	}
	interface IFarmWithDocu {
		Country: string;
		CustomerNumber: string;
		DocuFarmMatch: Data.Authentication.IFarmMatch[];
		ErpId: number;
		FarmExtent: string;
		FarmName: string;
		Id: number;
		Location: string;
		Message: string;
		PostalCode: string;
		Sourcestatus: number;
		State: string;
		Status: number;
		Street: string;
		Street2: string;
		StreetNo: string;
		Town: string;
		ZipCode: string;
		ZoomPosition: number;
	}
	interface IInvitations {
		Activation_Code: number;
		Confirmation_Time: Date;
		Created: Date;
		Created_Userid: number;
		DriverId: System.IGuid;
		Email: string;
		Farmid: number;
		Id: number;
		Isdriver: boolean;
		Usergroupid: number;
		Version: number;
	}
	interface ILogin {
		Email: string;
		LoginTime: number;
		Password: string;
		SessionDuration: number;
	}
	interface ILoginFailedAttemps {
		Email: string;
		Id: number;
		IpAddress: string;
		LoginAt: Date;
		User: Data.Authentication.IUser;
	}
	interface IPasswordRecovery {
		Connectioninfo: string;
		Email: string;
		Id: number;
		Password: string;
		Recoverycode: string;
		Recoverysuccess: boolean;
		Recoverytime: Date;
	}
	interface IUser {
		EMail: string;
		FAX: string;
		Forename: string;
		Id: number;
		IsConsultant: boolean;
		IsLocked: boolean;
		Language: string;
		LastReadNews: number;
		Mobile: string;
		PasswordHash: string;
		Phone: string;
		RedirectToNews: boolean;
		RoleId: number;
		RoleType: Data.Authentication.Enums.UserRoleType;
		SessionHash: string;
		Surname: string;
		UserName: string;
	}
	interface IUserSettings extends Data.Api.IBaseEntity {
		CountryCodes: string[];
		DocuPics: Data.Authentication.IUserSettingsMapping[];
		Id: number;
		UserId: number;
	}
	interface IUserSettingsMapping {
		Icon: string;
		Key: string;
	}
}
declare namespace Data.Authentication.Enums {
	export const enum ActionType {
		Movement = 0,
		No_Movement = 1
	}
	export const enum FarmTypes {
		Normal = 0,
		Customer = 1,
		WagesCompany = 2
	}
	export const enum UserRoleType {
		Default = 0,
		Admin = 1,
		Developer = 10
	}
}
declare namespace Data.BaseData {
	interface ICropCategories extends Data.UserType.ICacheModel {
		Categoryname: string;
	}
	interface ICropGroups extends Data.UserType.ICacheModel {
		Colordefault: string;
		FarmColor: string;
		FarmCropGroup: Data.BaseData.IFarmCropGroup[];
		Key: string;
	}
	interface ICropTypes extends Data.Api.IBaseEntity {
		CategoryId: number;
		CategoryKey: string;
		Categoryname: string;
		Color: string;
		CropKey: number;
		Description: string;
		Eppocode: string;
		EppoGroups: string[];
		EuFiltrationK: number;
		EuFiltrationMg: number;
		EuFiltrationP: number;
		ExpectedYield: number;
		Groupname: string;
		Id: number;
		IsSensorCrop: boolean;
		IsSystem: boolean;
		Landuse: number;
		MainwdK: number;
		MainwdMg: number;
		MainwdN: number;
		MainwdP: number;
		MsRatio: number;
		NSupply: number;
		PfBoxEppoCode: string;
		SecwdK: number;
		SecwdMg: number;
		SecwdN: number;
		SecwdP: number;
		Selected: boolean;
		SensorTypeId: number;
		Shortname: string;
		Thresholds: string;
		YaraSensorKey: string;
	}
	interface ICropTypesDetails extends Data.Api.IBaseEntity {
		CropKey: number;
		Description: string;
		EuFiltrationK: number;
		EuFiltrationMg: number;
		EuFiltrationP: number;
		ExpectedYield: number;
		Id: number;
		MainwdK: number;
		MainwdMg: number;
		MainwdN: number;
		MainwdP: number;
		MsRatio: number;
		NSupply: number;
		Presel: boolean;
		SecwdK: number;
		SecwdMg: number;
		SecwdN: number;
		SecwdP: number;
		Thresholds: string;
	}
	interface IDateRange {
		End: Date;
		Id: System.IGuid;
		Start: Date;
	}
	interface IDateRangeAssigment {
		DateRanges: Data.BaseData.IDateRange[];
		Id: System.IGuid;
	}
	interface IEffectiveRange {
		Description: string;
		Id: string;
		Key: string;
	}
	interface IFarmCropGroup extends Data.Api.IBaseEntity {
		Colorcode: string;
		Cropgroupid: number;
		Id: number;
	}
	interface IFertilizerInorg extends Data.Api.IBaseEntity {
		AlkalineCaO: number;
		AlkalineEff: boolean;
		ContentCaO: number;
		ContentK: number;
		ContentMg: number;
		ContentN: number;
		ContentP: number;
		ContentS: number;
		Density: number;
		DMPercent: number;
		Efficiency: number;
		EquivCaO: number;
		Id: number;
		IsLiquid: boolean;
		IsOrganic: boolean;
		Note: string;
		Prodname: string;
		RealContentCaO: number;
		Selectable: boolean;
		Unit: Data.Common.IUnit;
	}
	interface IFertilizerOrg extends Data.Api.IBaseEntity {
		AlkalineCaO: number;
		AlkalineEff: boolean;
		ContentCaO: number;
		ContentK: number;
		ContentMg: number;
		ContentN: number;
		ContentP: number;
		ContentS: number;
		Density: number;
		DMPercent: number;
		Efficiency: number;
		Id: number;
		IsLiquid: boolean;
		IsOrganic: boolean;
		Note: string;
		Prodname: string;
		RealContentCaO: number;
		Selectable: boolean;
		Unit: Data.Common.IUnit;
	}
	interface ILanduse {
		Id: number;
		Key: string;
		Version: number;
	}
	interface IMachineType {
		Culture: string;
		Description: string;
		Id: number;
		LayerCategoryId: number;
		Type: number;
	}
	interface IPlantProtectionProduct extends Data.Api.IBaseEntity {
		Country: Data.Common.ICountry;
		ExternalProductId: string;
		Id: System.IGuid;
		Ingredients: string;
		Note: string;
		PermissionEnd: Date;
		PermissionStart: Date;
		ProductDetails: Data.BaseData.IPlantProtectionProductDetails[];
		ProductName: string;
		Selectable: boolean;
		UseByDate: Date;
	}
	interface IPlantProtectionProductDetails extends Data.Api.IBaseEntity {
		AmountMax: number;
		EcMax: number;
		EcMin: number;
		EffectiveRange: Data.BaseData.IEffectiveRange;
		EppoCrop: string;
		EppoHarmfulOrganism: string;
		GrowthStageDefined: boolean;
		Id: System.IGuid;
		Indicator: string;
		ProductId: string;
		Unit: Data.Common.IUnit;
		WorkType: Data.BaseData.IWorktypes;
	}
	interface IPlantProtectionProductDetailsWriteable extends Data.Api.IBaseEntity {
		AmountMax: number;
		EcMax: number;
		EcMin: number;
		EffectiveRange: Data.BaseData.IEffectiveRange;
		EppoCrop: string;
		EppoHarmfulOrganism: string;
		GrowthStageDefined: boolean;
		Id: System.IGuid;
		Indicator: string;
		ProductId: System.IGuid;
		Unit: Data.Common.IUnit;
		WorkType: Data.BaseData.IWorktypes;
	}
	interface IPlantProtectionProductWriteable extends Data.Api.IBaseEntity {
		Country: Data.Common.ICountry;
		ExternalProductId: string;
		Id: System.IGuid;
		Note: string;
		PermissionEnd: Date;
		PermissionStart: Date;
		ProductDetails: Data.BaseData.IPlantProtectionProductDetailsWriteable[];
		ProductName: string;
		UseByDate: Date;
	}
	interface ISelectableCrops extends Data.Api.IBaseEntity {
		CropkeyDetailId: number;
		Id: number;
	}
	interface ISelectableFertilizer extends Data.Api.IBaseEntity {
		Count: number;
		Efficiency: number;
		FertilizerId: number;
		Id: number;
		IsOrganic: boolean;
		Rate: number;
		Selectable: boolean;
	}
	interface ISelectablePpProduct extends Data.Api.IBaseEntity {
		Id: number;
		PpProductId: System.IGuid;
	}
	interface ISelectableVariety extends Data.Api.IBaseEntity {
		Id: number;
		Varietyid: number;
	}
	interface ISettings extends Data.Api.IBaseEntity {
		DigitsAfterDecimalPoint: number;
		FarmTime: string;
		Id: number;
		IsOxidFarm: boolean;
		SelectedLanguageKey: string;
		UnitElementOxyd: number;
		UseMethodEuf: boolean;
	}
	interface ISubFarms extends Data.Api.IBaseEntity {
		City: string;
		Email: string;
		Fax: string;
		Id: number;
		Name: string;
		Nummer: string;
		Postalcode: string;
		Street: string;
		Telephone_Nr: string;
	}
	interface ITerminals extends Data.Api.IBaseEntity {
		CustomerNumber: string;
		Id: System.IGuid;
		LastService: Date;
		MailAddress: string;
		Sensor: string;
		SensorSn: string;
		SystemId: number;
		Terminal: string;
		TerminalSn: string;
	}
	interface ITimeZones {
		Name: string;
		Shortname: string;
	}
	interface IUserContacts extends Data.Api.IBaseEntity {
		FarmName: string;
		Firstname: string;
		Id: System.IGuid;
		IsActive: boolean;
		Lastname: string;
		MailAddress: string;
	}
	interface IVarieties {
		CroptypesCropkey: number;
		Flattenedrisk: number;
		Id: number;
		IdentificationNumber: number;
		Prodname: string;
		Selectable: boolean;
		SpecificReferences: string;
		Tkg: number;
		Version: number;
		YearOfPermission: number;
	}
	interface IWorktypes {
		Category: number;
		Category_Text: string;
		Description: string;
		Fertilisers: boolean;
		Id: number;
		Shortname: string;
		SubCategory: number;
		Type: number;
		Unit: string[];
		Wt_Unit: string;
	}
	interface IWorktypeUnit {
		Id: System.IGuid;
		UnitId: number;
		WorktypeId: number;
	}
}
declare namespace Data.BaseData.Map {
	interface ICategoryTheme {
		CalculationMethod: string;
		Id: number;
		IsDefault: boolean;
		IsUsed: boolean;
		LayerCategoryId: number;
		LayerId: number;
		Name: string;
		TestId: number;
		ThemeOrder: boolean;
		ThemeXml: string;
		ZoomScale: number;
	}
}
declare namespace Data.Client {
	interface IClientException {
		FarmId: number;
		FullState: string;
		Level: string;
		Message: string;
		Meta: string;
		StackTrace: string;
	}
	interface IClientStatus {
		GolangOnline: boolean;
		Id: System.IGuid;
		InvokerOnline: boolean;
		MapFactoryOnline: boolean;
		MongoOnline: boolean;
		PostgresOnline: boolean;
	}
}
declare namespace Data.Common {
	interface IAgriportConstants {
		Id: System.IGuid;
		Key: string;
		Value: string;
	}
	interface IApplicationMode {
		Description: string;
		Id: number;
		Key: string;
	}
	interface IContactInformation {
		Email: string;
		Geom: string;
		Geometry: NetTopologySuite.Geometries.IGeometry;
		Id: number;
		Img_Src_Path: string;
		Language_Key: string;
		Order: number;
		Tel: string;
		Version: number;
	}
	interface ICountry {
		Description: string;
		Id: string;
		TranslationKey: string;
	}
	interface ICountryGroup {
		Description: string;
		Id: string;
		Priority: number;
		TranslationKey: string;
	}
	interface IElement {
		Description: string;
		Id: number;
		Key: string;
		ShortDescription: string;
		ShortKey: string;
	}
	interface IExportFormat {
		Description: string;
		Id: number;
		Key: string;
	}
	interface IExportTarget {
		Description: string;
		Id: number;
		Key: string;
	}
	interface IFactors {
		Factor: number;
		Id: number;
		Source: Data.Common.IUnit;
		Target: Data.Common.IUnit;
	}
	interface IHelpArticles {
		ContentHtml: string;
		CreatedAt: Date;
		Id: System.IGuid;
		LanguageKey: string;
		TargetComponent: string;
	}
	interface INotifications extends Data.Api.IBaseEntity {
		Caption: string;
		Description: string;
		Id: System.IGuid;
		Link: string;
		Timestamp: Date;
		UserId: number;
		WasRead: boolean;
	}
	interface INUptakeFactors {
		EcMax: number;
		EcMin: number;
		EppoCode: string;
		Id: number;
		Interc: number;
		Slope: number;
	}
	interface IOperationMode {
		Description: string;
		Id: number;
		Key: string;
		LoggerId: number;
		Note: string;
	}
	interface IUnit {
		BaseUnit: Data.Common.IUnit;
		Description: string;
		Id: number;
		Key: string;
	}
}
declare namespace Data.Dashboard {
	interface INews {
		Caption: string;
		Culture: string;
		Description: string;
		Id: number;
		Linkpath: string;
		Newschain: boolean;
		Newshtml: string;
		Newskey: number;
		Publishdate: Date;
		Visible: boolean;
	}
}
declare namespace Data.DocuContext {
	interface IDocuContextCreateModelBase {
		FarmId: number;
	}
	interface IDocuContextDeleteModelBase {
		FarmId: number;
		Id: string;
	}
	interface IDocuContextReadModelBase {
		FarmId: number;
		Id: string;
	}
	interface IDocuContextUpdateModelBase {
		FarmId: number;
		Id: string;
	}
}
declare namespace Data.DocuContext.ApplicationData {
	interface IReadApplicationModel {
		Key: string;
		Unit: string;
		Value: string;
	}
}
declare namespace Data.DocuContext.Attachment {
	interface IAttachment extends Data.Api.IBaseEntity {
		Application: Data.DocuContext.Attachment.IAttachmentApplication[];
		Comment: string;
		Driver: Data.DocuContext.Driver.IDriver;
		From: Date;
		Id: System.IGuid;
		Instrument: Data.DocuContext.Instrument.IInstrument;
		IsModified: boolean;
		Logger: Data.DocuContext.Logger.ILogger;
		Machine: Data.DocuContext.Machine.IMachine;
		Mapping: Data.DocuContext.Attachment.IAttachmentMapping[];
		Status: number;
		To: Date;
		Valid: boolean;
		WorkingWidth: number;
		WorkType: Data.BaseData.IWorktypes;
		WorkTypeUnit: string;
	}
	interface IAttachmentApplication {
		Key: string;
		Unit: string;
		Value: number;
	}
	interface IAttachmentMapping {
		Factor: string;
		Name: string;
		Unit: string;
	}
}
declare namespace Data.DocuContext.Daystatus {
	interface IDaystatus extends Data.Api.IBaseEntity {
		Id: System.IGuid;
		LastResult: number;
		LastResultText: string;
		LastRun: Date;
		Machine: Data.DocuContext.Machine.IMachine;
		TaskDay: Date;
	}
}
declare namespace Data.DocuContext.Driver {
	interface ICreateDriverModel extends Data.DocuContext.IDocuContextCreateModelBase {
		Firstname: string;
		Name: string;
		Shortname: string;
	}
	interface IDriver extends Data.Api.IBaseEntity {
		Firstname: string;
		FullName: string;
		Id: System.IGuid;
		IsDeleted: boolean;
		Name: string;
		ShortFullName: string;
	}
	interface IReadDriverModel extends Data.DocuContext.IDocuContextReadModelBase {
		Firstname: string;
		Name: string;
		Shortname: string;
	}
	interface IUpdateDriverModel extends Data.DocuContext.IDocuContextUpdateModelBase {
		Firstname: string;
		Name: string;
		Shortname: string;
	}
}
declare namespace Data.DocuContext.DriversMachines {
	interface ICreateDriversMachinesModel extends Data.DocuContext.IDocuContextCreateModelBase {
		DateFrom: string;
		DateTo: string;
		DriverId: string;
		MachineId: string;
	}
	interface IDriverMachine extends Data.Api.IBaseEntity {
		DateFrom: Date;
		DateTo: Date;
		Driver: Data.DocuContext.Driver.IDriver;
		Id: System.IGuid;
		IsDeleted: boolean;
		Machine: Data.DocuContext.Machine.IMachine;
	}
	interface IReadDriversMachinesModel extends Data.DocuContext.IDocuContextReadModelBase {
		DateFrom: string;
		DateTo: string;
		Driver: Data.DocuContext.Driver.IReadDriverModel;
		Machine: Data.DocuContext.Machine.IReadMachineModel;
	}
	interface IUpdateDriversMachinesModel extends Data.DocuContext.IDocuContextUpdateModelBase {
		DateFrom: string;
		DateTo: string;
		DriverId: string;
		MachineId: string;
	}
}
declare namespace Data.DocuContext.FleetManagement {
	interface IFieldAction {
		Attachment: Data.DocuContext.Attachment.IAttachment;
		FieldId: System.IGuid;
		Id: System.IGuid;
		Slice: Data.DocuContext.Slice.ICombinedSlice;
	}
	interface IFleetAction {
		AttachmentCount: number;
		Id: System.IGuid;
		LastAction: Date;
		Status: number;
	}
	interface IFleetActionAttachment {
		Attachment: Data.DocuContext.Attachment.IAttachment;
		FieldId: System.IGuid;
		Id: System.IGuid;
		LastAction: Date;
		Slices: Data.DocuContext.Slice.ISlice[];
		Status: number;
	}
}
declare namespace Data.DocuContext.Instrument {
	interface ICreateInstrumentModel extends Data.DocuContext.IDocuContextCreateModelBase {
		DefaultWidth: number;
		DefaultWorktype: number;
		IsDeleted: boolean;
		Name: string;
		Shortname: string;
		Unit: string;
	}
	interface IInstrument extends Data.Api.IBaseEntity {
		DefaultWidth: number;
		DefaultWorktype: Data.BaseData.IWorktypes;
		Id: System.IGuid;
		IsDeleted: boolean;
		Name: string;
		Type: number;
		Unit: string;
	}
	interface IReadInstrumentModel extends Data.DocuContext.IDocuContextReadModelBase {
		DefaultWidth: number;
		DefaultWorktype: number;
		IsDeleted: boolean;
		Name: string;
		Shortname: string;
		Unit: string;
	}
	interface IUpdateInstrumentModel extends Data.DocuContext.IDocuContextUpdateModelBase {
		DefaultWidth: number;
		DefaultWorktype: number;
		IsDeleted: boolean;
		Name: string;
		Shortname: string;
		Unit: string;
	}
}
declare namespace Data.DocuContext.Location {
	interface ILocationModel {
		Datum: string;
		DeviceId: string;
		GpsDate: string;
		GpsTime: string;
		HHId: number;
		Id: System.IGuid;
		Imei: string;
		Kind: number;
		Latitude: number;
		Longitude: number;
		Name: string;
		Sign: string;
		Speed: number;
		Zeit: string;
	}
	interface ILocationsEnvelop {
		FarmId: number;
		Locations: Data.DocuContext.Location.ILocationModel[];
	}
}
declare namespace Data.DocuContext.Logger {
	interface ICreateLoggerModel extends Data.DocuContext.IDocuContextCreateModelBase {
		Imei: string;
		Typ: string;
	}
	interface ILogger extends Data.Api.IBaseEntity {
		Id: System.IGuid;
		Imei: string;
		IsDeleted: boolean;
		NewPassword: string;
		Password: number[];
		PwSalt: string;
		SendTarget: number;
		Typ: string;
	}
	interface IReadLoggerModel extends Data.DocuContext.IDocuContextReadModelBase {
		Imei: string;
		IsDeleted: boolean;
		SendTarget: string;
		Typ: string;
	}
	interface IUpdateLoggerModel extends Data.DocuContext.IDocuContextUpdateModelBase {
		Imei: string;
		IsDeleted: boolean;
		SendTarget: string;
		Typ: string;
	}
}
declare namespace Data.DocuContext.Machine {
	interface ICreateMachineModel extends Data.DocuContext.IDocuContextCreateModelBase {
		DefaultInstrumentId: string;
		DefaultWidth: string;
		HhId: number;
		IsDeleted: boolean;
		Kind: number;
		Name: string;
		Shortname: string;
		Sign: string;
	}
	interface IMachine extends Data.Api.IBaseEntity {
		DefaultDriver: Data.DocuContext.Driver.IDriver;
		DefaultInstrument: Data.DocuContext.Instrument.IInstrument;
		DefaultWidth: number;
		HHID: number;
		Id: System.IGuid;
		IsDeleted: boolean;
		Kind: number;
		Name: string;
		NameWithSign: string;
		Sign: string;
	}
	interface IMachineBreak {
		Color: string;
		Description: string;
		Kind: number;
		Property: string;
		Value: number;
	}
	interface IReadMachineModel extends Data.DocuContext.IDocuContextReadModelBase {
		DefaultInstrumentId: string;
		DefaultWidth: string;
		HhId: number;
		IsDeleted: boolean;
		Kind: number;
		Name: string;
		Shortname: string;
		Sign: string;
	}
	interface IUpdateMachineModel extends Data.DocuContext.IDocuContextUpdateModelBase {
		DefaultInstrumentId: string;
		HhId: number;
		IsDeleted: boolean;
		Kind: number;
		Name: string;
		Sign: string;
	}
}
declare namespace Data.DocuContext.MachinesLogger {
	interface ICreateMachinesLoggerModel extends Data.DocuContext.IDocuContextCreateModelBase {
		DateFrom: string;
		DateTo: string;
		LoggerId: string;
		MachineId: string;
	}
	interface IMachinesLogger extends Data.Api.IBaseEntity {
		DateFrom: Date;
		DateTo: Date;
		Id: System.IGuid;
		IsDeleted: boolean;
		Logger: Data.DocuContext.Logger.ILogger;
		Machine: Data.DocuContext.Machine.IMachine;
	}
	interface IReadMachinesLoggerModel extends Data.DocuContext.IDocuContextReadModelBase {
		DateFrom: string;
		DateTo: string;
		IsDeleted: boolean;
		Logger: Data.DocuContext.Logger.IReadLoggerModel;
		Machine: Data.DocuContext.Machine.IReadMachineModel;
	}
	interface IUpdateMachinesLoggerModel extends Data.DocuContext.IDocuContextUpdateModelBase {
		DateFrom: string;
		DateTo: string;
		IsDeleted: boolean;
		LoggerId: string;
		MachineId: string;
	}
}
declare namespace Data.DocuContext.Slice {
	interface ICombinedSlice extends Data.DocuContext.Slice.ISlice {
		MovementProcessing: Data.DocuContext.Slice.ISliceProcessing[];
		MovementTime: number;
		NumSlices: number;
		StandstillProcessing: Data.DocuContext.Slice.ISliceProcessing[];
		StandstillTime: number;
	}
	interface ISlice extends Data.Api.IBaseEntity {
		Attachment: Data.DocuContext.Attachment.IAttachment;
		BruttoArea: number;
		Duration: number;
		FieldIdOnEnd: System.IGuid;
		FieldIdOnStart: System.IGuid;
		From: Date;
		GroupId: number;
		Hhid: number;
		Id: System.IGuid;
		Imei: string;
		InField: boolean;
		NettoArea: number;
		NumPoints: number;
		Processing: Data.DocuContext.Slice.ISliceProcessing[];
		To: Date;
		Type: Data.Authentication.Enums.ActionType;
		Valid: boolean;
		Way: number;
	}
	interface ISliceFilter {
		Actions: Data.Authentication.Enums.ActionType[];
		CropTypes: Data.BaseData.ICropTypes[];
		Drivers: Data.DocuContext.Driver.IDriver[];
		Fields: System.IGuid[];
		Instruments: Data.DocuContext.Instrument.IInstrument[];
		Machines: Data.DocuContext.Machine.IMachine[];
		WorkTypes: Data.BaseData.IWorktypes[];
	}
	interface ISliceProcessing {
	}
	interface ISliceProcessingUserType extends Data.UserType.IJsonbGenericUserType {
	}
}
declare namespace Data.DocuContext.UserData {
	interface IReadUserDataModel extends Data.DocuContext.IDocuContextReadModelBase {
		ActionId: string;
		Applications: Data.DocuContext.ApplicationData.IReadApplicationModel[];
		Comment: string;
		Driver: Data.DocuContext.Driver.IReadDriverModel;
		DriverId: string;
		Instrument: Data.DocuContext.Instrument.IReadInstrumentModel;
		InstrumentId: string;
		IsModified: string;
		Unit: string;
		Valid: boolean;
		WorkingWidth: string;
		Worktype: number;
	}
}
declare namespace Data.Dpl3 {
	interface ILabResultAttachment extends Data.Api.IBaseEntity {
		ContentBase64: string;
		ContentMimeType: string;
		ContentSize: number;
		Id: System.IGuid;
		LastModified: number;
		Name: string;
		Note: string;
	}
}
declare namespace Data.FieldManagement {
	interface ICropRotation {
		AreaHa: number;
		FieldName: string;
		FieldNumber: number;
		FieldSubNumber: number;
		Id: System.IGuid;
		ValidFrom: Date;
		ValidTo: Date;
		Yields: Data.FieldManagement.ICropRotationYield[];
	}
	interface ICropRotationAttributes {
		CountDistinctYears: number;
		CropRotationNeed: Data.FieldManagement.ICropRotationNeed;
		FieldGeomId: System.IGuid;
		HasIrRaster: boolean;
		HasRbRaster: boolean;
		HasWsvRaster: boolean;
		IsCropClosed: boolean;
	}
	interface ICropRotationCell {
		FieldId: System.IGuid;
		MainCrop: number;
		MainCropStraw: boolean;
		MainCropYield: number;
		SecondCrop: number;
		SecondCropYield: number;
		Year: number;
		YearIndex: number;
	}
	interface ICropRotationNeed {
		CropRotationNeedCaO: number;
		CropRotationNeedK: number;
		CropRotationNeedMg: number;
		CropRotationNeedP: number;
	}
	interface ICropRotationYield {
		MainCrop: number;
		MainCropStraw: boolean;
		MainCropYield: number;
		SecondCrop: number;
		SecondCropYield: number;
	}
	interface IField extends Data.Api.IBaseEntity {
		CampaignYear: number;
		DefaultGeom: Data.FieldManagement.IFieldGeom;
		FieldBlock: string;
		FieldCrops: Data.FieldManagement.IFieldCrop[];
		FieldGeoms: Data.FieldManagement.IFieldGeom[];
		FieldGroup: System.IGuid;
		FieldId: number;
		FieldName: string;
		FieldNumber: number;
		FieldSubnumber: number;
		FieldType: number;
		GridSize: number;
		Id: System.IGuid;
		Note: string;
		ValidFrom: Date;
		ValidTo: Date;
	}
	interface IFieldBase {
		FarmId: number;
		FieldCrops: Data.FieldManagement.IFieldCrop[];
		FieldName: string;
		FieldNumber: number;
		FieldSubnumber: number;
		Id: System.IGuid;
		ValidFrom: Date;
		ValidTo: Date;
	}
	interface IFieldCrop extends Data.Api.IBaseEntity {
		AdminArea: number;
		AreaHa: number;
		CampaignYear: number;
		Color: string;
		Cropkey: number;
		CroptypeId: number;
		CroptypeSecondId: number;
		EcValue: number;
		EppoCode: string;
		ExpectedYield: number;
		ExpectedYieldSecond: number;
		FieldId: System.IGuid;
		HarvestAttachment: Data.DocuContext.Attachment.IAttachment;
		Id: System.IGuid;
		Intercrop: number;
		MainSecondCropType: number;
		Note: string;
		ScenarioId: System.IGuid;
		StrawHarvested: boolean;
		ValidFrom: Date;
		ValidTo: Date;
		Variety: System.IGuid;
	}
	interface IFieldCropRotation extends Data.FieldManagement.ICropRotation {
		Children: Data.FieldManagement.ICropRotation[];
	}
	interface IFieldCropRotationHistory {
		CropRotation: any;
		FieldId: System.IGuid;
	}
	interface IFieldGeom extends Data.Api.IBaseEntity {
		AdminArea: number;
		AreaHa: number;
		CampaignYear: number;
		FieldGeomPackages: Data.FieldManagement.IFieldGeomPackage[];
		FieldId: System.IGuid;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Id: System.IGuid;
		Note: string;
		Status: string;
		ValidFrom: Date;
		ValidTo: Date;
	}
	interface IFieldGeomPackage {
		FieldGeomId: System.IGuid;
		PackageId: System.IGuid;
		Year: number;
	}
	interface IFieldGrowth {
		Commodity: System.IGuid;
		Farm_Id: number;
		Field_Crop_Id: System.IGuid;
		Harvest: boolean;
		Harvest_Date: Date;
		Id: System.IGuid;
		Object_Version: number;
		Scenario_Id: System.IGuid;
		Unit_Weight: number;
		Units: number;
		Version: number;
		Yield: number;
	}
	interface IFieldIntegrateResult {
		ErrorMessage: string;
		Geom: Data.Geometry.IGeoJsonPolygon;
	}
	interface IFieldYield {
		Farm_Id: number;
		Field_Growth_Id: System.IGuid;
		Id: System.IGuid;
		Note: string;
		Object_Version: number;
		Scenario_Id: System.IGuid;
		Srid: number;
		Version: number;
	}
}
declare namespace Data.Fields {
	interface IMonitoringDetail extends Data.Api.IBaseEntity {
		Attachments: Data.Fields.IMonitoringDetailAttachmentWithoutContent[];
		Date: Date;
		EcStage: number;
		Id: System.IGuid;
		MonitoringFieldId: System.IGuid;
		Notes: string;
		Position: NetTopologySuite.Geometries.IPoint;
		Recommendation: number;
		RecommendationUnit: Data.Common.IUnit;
		TypeId: number;
		Value: number;
		ValueUnit: Data.Common.IUnit;
	}
	interface IMonitoringDetailAttachment extends Data.Fields.IMonitoringDetailAttachmentWithoutContent {
		ContentBase64: string;
	}
	interface IMonitoringDetailAttachmentWithoutContent extends Data.Api.IBaseEntity {
		ContentMimeType: string;
		ContentSize: number;
		Id: System.IGuid;
		MonitoringDetailId: System.IGuid;
		Name: string;
		Note: string;
		ThumbnailBase64: string;
		ThumbnailMimeType: string;
		ThumbnailSize: number;
	}
	interface IMonitoringField extends Data.Api.IBaseEntity {
		FieldId: System.IGuid;
		Id: System.IGuid;
		Year: number;
	}
	interface IMonitoringType {
		Description: string;
		Id: number;
		Recommendation: boolean;
		RecommendationUnit: Data.Common.IUnit;
		RulesRecommendation: boolean;
		TranslationKey: string;
		Value: boolean;
		ValueUnit: Data.Common.IUnit;
	}
}
declare namespace Data.FungidetectManagement {
	interface IFungidetect {
		Field_Id: System.IGuid;
		Id: System.IGuid;
		Log: Data.Import.ILog;
	}
	interface IFungidetectDetail {
		Id: System.IGuid;
		Logs: Data.Import.ILog[];
	}
}
declare namespace Data.Geometry {
	interface IGeoJsonLine {
		Coordinates: number[][];
		Type: string;
	}
	interface IGeoJsonMultiLine {
		Coordinates: number[][][];
		Type: string;
	}
	interface IGeoJsonMultiPoint {
		Coordinates: number[][];
		Type: string;
	}
	interface IGeoJsonMultiPolygon {
		Coordinates: number[][][][];
		Type: string;
	}
	interface IGeoJsonPoint {
		Coordinates: number[];
		Type: string;
	}
	interface IGeoJsonPolygon {
		Coordinates: number[][][];
		Type: string;
	}
}
declare namespace Data.GeometryEditor {
	export const enum GeometryUpdateType {
		INSERT = 0,
		UPDATE = 1,
		DELETE = 2
	}
	interface IGeometryUpdate {
		Geom: string;
		Type: Data.GeometryEditor.GeometryUpdateType;
	}
}
declare namespace Data.Import {
	interface ICsvColumn {
		ColumnAlias: string;
		ColumnName: string;
		ColumnOrder: number;
		ColumnType: string;
		CsvType: Data.Import.ICsvType;
		Id: number;
		Import: boolean;
	}
	interface ICsvHeaderColumn {
		ColumnAlias: string;
		ColumnName: string;
		ColumnOrder: number;
		ColumnType: string;
		CsvHeaderType: Data.Import.ICsvHeaderType;
		Id: number;
		Import: boolean;
	}
	interface ICsvHeaderType {
		CsvHeaderColumns: Data.Import.ICsvHeaderColumn[];
		CsvType: Data.Import.ICsvType;
		Delimiter: string;
		Id: number;
		IdentityDesc: string;
	}
	interface ICsvType {
		CsvColumns: Data.Import.ICsvColumn[];
		DataSetHeader: number;
		DataSetType: Data.Import.IDataSetType;
		DateColumn: string;
		HeightColumn: string;
		Id: number;
		LatColumn: string;
		LonColumn: string;
		TimeColumn: string;
		ValueDefinitions: string[];
	}
	interface IDataSet {
		Created: Date;
		DataSetName: string;
		DataSetType: Data.Import.IDataSetType;
		ErrCode: string;
		FarmId: number;
		HeaderValues: Data.Import.IHeaderValues;
		HeaderValuesString: string;
		Id: System.IGuid;
		Imported: Date;
		MongoFileId: string;
		Uploaded: Date;
		Version: number;
	}
	interface IDataSetColumn {
		ColumnAlias: string;
		ColumnName: string;
		ColumnOrder: number;
		ColumnType: string;
		DataSetType: Data.Import.IDataSetType;
		Id: number;
	}
	interface IDataSetType {
		CategoryId: number;
		DataSetName: string;
		DecimalSeparator: string;
		FieldSeparator: string;
		FileType: string[];
		GeometryType: string[];
		Id: number;
		ProcessingType: number;
		Version: number;
	}
	interface IHeaderValues {
	}
	interface IImportDataSet {
		Created: Date;
		DataSetName: string;
		DataSetType: Data.Import.IDataSetType;
		ErrCode: string;
		FarmId: number;
		HeaderValues: Data.Import.IHeaderValues;
		HeaderValuesString: string;
		Id: System.IGuid;
		Imported: Date;
		LogCount: number;
		MongoFileId: string;
		Uploaded: Date;
		User: string;
		Version: number;
	}
	interface IImportFile {
		CreatedDate: Date;
		Dataset: boolean;
		FileName: string;
		Id: System.IGuid;
		ImportDate: Date;
		LogFile: boolean;
		Points: boolean;
		User: string;
	}
	interface ILog {
		CollectionTime: Date;
		DataSet: Data.Import.IDataSet;
		FarmId: number;
		GeoJsonGeom: string;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Id: System.IGuid;
		ValuesString: string;
		Z: number;
	}
	interface INSensorLogHeaderData extends Data.Import.ISensorLogHeaderData {
		BiomassCutoffFactor: string;
		Cutoff: string;
		DeadBiomass: string;
		MineralisationOffset: string;
		ReferenceRate: string;
		SnValue: string;
	}
	interface IPlantProtectionSensorLogAgentData {
		AMax: string;
		AMaxAbs: string;
		AMin: string;
		AStd: string;
		Id: string;
		Name: string;
		Number: number;
		Scope: string;
		Unit: string;
	}
	interface IPlantProtectionSensorLogHeaderData extends Data.Import.ISensorLogHeaderData {
		Agents: Data.Import.IPlantProtectionSensorLogAgentData[];
		AgentSlope: string;
		FlattenedRisk: string;
		NumAgents: string;
		SensorFertilization: string;
		SnReference: string;
		WaterSupply: string;
		ZeroRate: string;
	}
	interface ISensorLogHeaderData extends Data.Import.IHeaderValues {
		Agent: string;
		AgentContent: string;
		ApplicationMode: number;
		Calibrate: boolean;
		Controller: string;
		CropType: string;
		EcStage: number;
		Maximum: string;
		Minimum: string;
		OperationMode: number;
		ResponseTime: string;
		SensorType: string;
		SignalDelay: string;
		Slope: string;
		Standard: string;
		WorkingWidth: number;
	}
}
declare namespace Data.IpsPlanning {
	interface ISoilSamplePlanning extends Data.Api.IBaseEntity {
		Description: string;
		FieldId: System.IGuid;
		Id: System.IGuid;
		LastSamplingdate: Date;
		OrganicApplication: boolean;
		PlannedSamplingdate: Date;
		PlannedScan: boolean;
		UserId: number;
	}
	interface ISoilSamplePlanningExportData {
		CropTypeName: string;
		CropTypeNameMinus1: string;
		CropTypeNamePlus1: string;
		CropTypeNamePlus2: string;
		FieldId: System.IGuid;
		GridSize: number;
		LastSampleDate: Date;
		PlannedScan: boolean;
		SampleAmount: number;
	}
}
declare namespace Data.Job {
	export const enum JobStatus {
		Error = -1,
		Pending = 0,
		Running = 1,
		Finished = 2,
		Postponed = -999
	}
	interface IJobs {
		Condition: string;
		CreatedAt: Date;
		Description: string;
		FarmId: number;
		FinishedAt: Date;
		Id: System.IGuid;
		Input: string;
		JobType: Data.Job.IJobTypes;
		LastActivityAt: Date;
		Output: string;
		Priority: number;
		Process: number;
		ProcessId: number;
		Schedule: Data.Job.ISchedule;
		StartedAt: Date;
		Status: Data.Job.JobStatus;
	}
	interface IJobsChanges {
		Job: Data.Job.IJobs;
		JobId: System.IGuid;
		Operation: Agriport.Invoker.Api.Database.DatabaseNotifyOperation;
	}
	interface IJobTypes {
		Id: number;
		MaxThreads: number;
		Name: string;
		Options: string;
		Target: string;
		TimeoutSec: number;
	}
	interface ISchedule {
		Id: System.IGuid;
		Input: string;
		Interval: System.ITimeSpan;
		JobType: Data.Job.IJobTypes;
		ScheduledAt: System.ITimeSpan;
		ScheduleEnd: System.ITimeSpan;
	}
}
declare namespace Data.Language {
	interface ILanguage {
		DateFormat: string;
		DateTimeFormat: string;
		DecimalSeperator: string;
		Key: string;
		LanguageName: string;
		Order: number;
		ThousandSeperator: string;
		TimeFormat: string;
	}
	interface ITranslation extends Data.UserType.ICacheModel {
		CountryCode: string;
		translation: string;
		TranslationKey: string;
		VersionsIndex: string;
	}
}
declare namespace Data.Licensing {
	interface IFeature {
		Description: string;
		Id: number;
		Key: string;
		Modul_Id: number;
		Translationkey: string;
		Version: number;
	}
	interface IFeatureModul {
		Description: string;
		ErpId: number;
		Id: number;
		Key: string;
		Translationkey: string;
		Version: number;
	}
	interface ILicense extends Data.Api.IBaseEntity {
		FeatureModul: Data.Licensing.IFeatureModul;
		Id: number;
		NextInvoiceDate: Date;
		NoCheck: boolean;
		QuantityErp: number;
		TrialActivationsCount: number;
		TrialExpireAt: Date;
		ValidFrom: Date;
		ValidTo: Date;
	}
}
declare namespace Data.Licensing.Enums {
	export const enum LicenseAdjustAction {
		Skip = 0,
		Adjust = 1
	}
}
declare namespace Data.MenuStructure {
	interface IMenuChildren {
		Active: boolean;
		CanNavigate: boolean;
		Enabled: boolean;
		Id: number;
		NeededFeatures: Data.Licensing.IFeature[];
		Order: number;
		Title: string;
		Url: string;
	}
	interface IMenuEntry extends Data.MenuStructure.IMenuChildren {
		Childs: Data.MenuStructure.IMenuChildren[];
		IconClass: string;
		IsGroup: boolean;
	}
}
declare namespace Data.Metrics {
	interface IModuleNavigation {
		Counter: number;
		Day: Date;
		FarmId: number;
		Id: number;
		ModuleUrl: string;
		UserId: number;
	}
}
declare namespace Data.NDI {
	interface INdiStatistic {
		Cells: number;
		Created: Date;
		FieldGeomId: System.IGuid;
		Histogram: System.Collections.Generic.IKeyValuePair[];
		Max: number;
		Mean: number;
		Median: number;
		Min: number;
		Most: number;
		ScanType: Data.NDI.Enums.ScanType;
		Sum: number;
	}
}
declare namespace Data.NDI.Enums {
	export const enum ScanType {
		Regular = 0,
		Autumn = 1
	}
}
declare namespace Data.NFertilization {
	interface ICropEcN {
		CropKeys: number[];
		EcMax: number;
		EcMin: number;
		Id: number;
		N1: number;
		N2: number;
		N3: number;
		N4: number;
		N5: number;
		N6: number;
		N7: number;
		N8: number;
		N9: number;
	}
	interface ICropEcSn {
		CropKeys: number[];
		EcMax: number;
		EcMin: number;
		Id: number;
		Sn1: number;
		Sn2: number;
		Sn3: number;
		Sn4: number;
		Sn5: number;
		Sn6: number;
		Sn7: number;
		Sn8: number;
		Sn9: number;
	}
	interface INFertilizationDetail {
		Attribute: string;
		Count: number;
		Cropkey: number;
		Date: Date;
		FileId: number;
		Growthstage: number;
		Id: number;
		Max: number;
		Mean: number;
		Min: number;
		Source: string;
		Stddev: number;
		Sum: number;
		Unit: string;
	}
	interface INFertilizationNeedValue {
		CampaignYear: number;
		FieldId: System.IGuid;
		Id: System.IGuid;
		Value: number;
	}
	interface INPlanningData {
		ApplicationMode: number;
		ApplRate: number;
		AutumnScan: number;
		Constant: number;
		DeadBioMass: number;
		FieldGeomId: System.IGuid;
		Maximum: number;
		Minimum: number;
		NdPlanId: System.IGuid;
		NUptake: number;
		PlanId: System.IGuid;
		PpPlanId: System.IGuid;
		SatId: System.IGuid;
		Slope: number;
		Threshold: number;
	}
}
declare namespace Data.Nutrients {
	export const enum SoilSampleFieldState {
		NO_INTERPOLATION = 0,
		INTERPOLATED = 1
	}
	interface IFieldDistribution {
		Class: number;
		FieldGeomId: System.IGuid;
		Geom: string;
		Id: number;
		Nutrient: string;
	}
	interface IFieldNutrientPlanningStatistic {
		Band: number;
		Cells: number;
		Duration: number;
		ErrorText: string;
		FieldGeomId: System.IGuid;
		FieldStatistic: Data.Nutrients.IStatisticHistogram[];
		Id: number;
		Max: number;
		Mean: number;
		Median: number;
		Min: number;
		Most: number;
		PlanId: System.IGuid;
		RasterStatistic: Data.Nutrients.IStatisticHistogram[];
		Sum: number;
	}
	interface IFieldNutrientsDistribution {
		AvgClassK: number;
		AvgClassMg: number;
		AvgClassP: number;
		AvgClassPh: number;
		AvgK: number;
		AvgMg: number;
		AvgP: number;
		AvgPh: number;
		BandCount: number;
		FarmId: number;
		FieldGeomId: System.IGuid;
		Histograms: Data.Nutrients.IHistogram[];
		Id: number;
		MethodK: string;
		MethodMg: string;
		MethodP: string;
		MethodPh: string;
		NewestSampleDate: Date;
		SoilGroups: number[];
		Srid: number;
	}
	interface IFieldNutrientsMap {
		Area: number;
		Class_K: string;
		Class_Mg: string;
		Class_P: string;
		Class_pH: string;
		Field_Name: string;
		Field_Number: string;
		Field_Subnumber: string;
		Id: number;
		K: number;
		Mg: number;
		P: number;
		pH: number;
		Sample_Date: Date;
		Soil_Groups: string;
	}
	interface IHistogram {
		Cells: number;
		Counters: number[];
		Key: string;
		Max: number;
		Mean: number;
		Min: number;
		Most: number;
		Sum: number;
		Values: number[];
	}
	interface IRasterCreationResult {
		ExitCode: number;
		Id: System.IGuid;
		Message: string;
	}
	interface IRasterStatistic {
		Cells: number;
		Histogram: System.Collections.Generic.IKeyValuePair[];
		Max: number;
		Mean: number;
		Median: number;
		Min: number;
		Most: number;
		Sum: number;
	}
	interface IRbStatistic {
		FieldGeomId: System.IGuid;
		Id: number;
		PackageId: string;
		PlanIds: System.IGuid[];
		RbOneAvgCao: number;
		RbOneAvgK: number;
		RbOneAvgMg: number;
		RbOneAvgP: number;
		RbOneStatisticCao: Data.Nutrients.IRasterStatistic;
		RbOneStatisticK: Data.Nutrients.IRasterStatistic;
		RbOneStatisticMg: Data.Nutrients.IRasterStatistic;
		RbOneStatisticP: Data.Nutrients.IRasterStatistic;
		RbTwoAvgCao: number;
		RbTwoAvgK: number;
		RbTwoAvgMg: number;
		RbTwoAvgP: number;
		RbTwoStatisticCao: Data.Nutrients.IRasterStatistic;
		RbTwoStatisticK: Data.Nutrients.IRasterStatistic;
		RbTwoStatisticMg: Data.Nutrients.IRasterStatistic;
		RbTwoStatisticP: Data.Nutrients.IRasterStatistic;
	}
	interface ISampleMethod {
		Id: number;
		Method: string;
		Oxide: boolean;
		Unit: number;
	}
	interface ISampleRegion {
		Id: number;
		Region: string;
		SoilSampleInterval: number;
	}
	interface ISampleTracks {
		Centroid: NetTopologySuite.Geometries.IGeometry;
		ClassK: string;
		ClassMg: string;
		ClassP: string;
		ClassPh: string;
		FarmId: number;
		FileId: number;
		Geom: NetTopologySuite.Geometries.IGeometry;
		GpsNumber: number;
		GpsNumber2: number;
		Guid: System.IGuid;
		Id: number;
		K: number;
		Landuse: Data.BaseData.ILanduse;
		MethodK: string;
		MethodMg: string;
		MethodP: string;
		MethodPh: string;
		Mg: number;
		N: number;
		P: number;
		Ph: number;
		RealSampleDate: Date;
		RecCa: number;
		RecK: number;
		RecMg: number;
		RecP: number;
		Region: string;
		SampleDate: Date;
		SampleField: Data.Nutrients.ISoilSampleField;
		SoilGroup: number;
	}
	interface ISoilSample {
		ClassK: string;
		ClassMg: string;
		ClassP: string;
		ClassPh: string;
		FarmId: number;
		FieldName: string;
		Geom: string;
		GpsNumber: number;
		Id: number;
		Landuse: number;
		MethodK: string;
		MethodMg: string;
		MethodP: string;
		SampleDate: Date;
		SampleFieldId: number;
		SessionHash: string;
		SoilGroup: number;
		ValueK: number;
		ValueMg: number;
		ValueN: number;
		ValueP: number;
		ValuePh: number;
	}
	interface ISoilSampleField {
		Area: number;
		AreaHa: number;
		ClassK: string;
		ClassMg: string;
		ClassP: string;
		ClassPh: string;
		FarmId: number;
		FieldId: number;
		FieldName: string;
		FieldNumber: number;
		FieldPart: number;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Guid: System.IGuid;
		Histograms: Data.Nutrients.IHistogram[];
		Id: number;
		K: number;
		LandUse: number;
		MethodK: string;
		MethodMg: string;
		MethodP: string;
		MethodPh: string;
		Mg: number;
		Number: string;
		P: number;
		Ph: number;
		Region: string;
		SampleDate: Date;
		SampleTracksCount: number;
		SoilGroups: string;
		SoilSamplingInterval: number;
		State: Data.Nutrients.SoilSampleFieldState;
	}
	interface ISoilSampleFieldDistribution {
		Class: number;
		Geom: string;
		Id: number;
		Nutrient: string;
		SampleFieldId: number;
	}
	interface IStatisticHistogram {
		Key: number;
		Value: number;
	}
}
declare namespace Data.Parameter {
	interface IListValuesMapping {
		Id: number;
		Name: string;
		TranslationKey: string;
	}
	interface IParameterDefinition {
		Countries: string[];
		Description: string;
		Id: System.IGuid;
		ListValues: Data.Parameter.IListValuesMapping[];
		Mandatory: boolean;
		Name: string;
		ParameterRefObjectType: Data.Parameter.Enums.ParameterRefObjectType;
		ParameterType: Data.Parameter.Enums.ParameterType;
		RefObjectId: number;
		Regex: string;
		StandardValue: string;
		TranslationKey: string;
		TypeId: number;
		Unit: string;
		Version: number;
	}
	interface IParameterValue extends Data.Api.IBaseEntity {
		DefinitionId: System.IGuid;
		Id: System.IGuid;
		RefId: System.IGuid;
		Valid: boolean;
		ValidFrom: Date;
		ValidTo: Date;
		ValueBoolean: boolean;
		ValueListKey: number;
		ValueNumber: number;
		ValueString: string;
		ValueTimestamp: Date;
	}
	interface IParameterValueHistory extends Data.Api.IBaseEntity {
		ChangedByName: string;
		CreatedByName: string;
		DefinitionId: System.IGuid;
		DeletedByName: string;
		Id: System.IGuid;
		NewValid: boolean;
		NewValidFrom: Date;
		NewValidTo: Date;
		NewValueBoolean: boolean;
		NewValueListKey: number;
		NewValueNumber: number;
		NewValueString: string;
		NewValueTimestamp: Date;
		OldValid: boolean;
		OldValidFrom: Date;
		OldValidTo: Date;
		OldValueBoolean: boolean;
		OldValueListKey: number;
		OldValueNumber: number;
		OldValueString: string;
		OldValueTimestamp: Date;
		Operation: string;
		OperationType: Data.Parameter.Enums.OperationType;
		RefId: System.IGuid;
	}
}
declare namespace Data.Parameter.Enums {
	export const enum OperationType {
		Update = 85,
		Delete = 68,
		Insert = 73
	}
	export const enum ParameterRefObjectType {
		Field = 0
	}
	export const enum ParameterType {
		Boolean = 0,
		Number = 1,
		Text = 2,
		TimeStamp = 3,
		List = 4
	}
}
declare namespace Data.PfBox {
	interface ICropApplNum {
		ApplNum: number;
		EcMax: number;
		EcMin: number;
		EppoCode: string;
	}
}
declare namespace Data.PlantProtection {
	interface IPlantProtectionLogEdit {
		DatasetFieldMapId: System.IGuid;
		DriverId: System.IGuid;
		InstrumentId: System.IGuid;
		MachineId: System.IGuid;
		PlanId: System.IGuid;
		Products: Data.PlantProtection.IPlantProtectionLogEditProduct[];
		WorkingWidth: number;
	}
	interface IPlantProtectionLogEditProduct {
		ProductId: System.IGuid;
		Rate: number;
		Unit: string;
	}
}
declare namespace Data.Sampling {
	interface IDynamicClusterSample {
	}
}
declare namespace Data.Sensor {
	interface IDatasetFieldMap {
		Amount: number;
		ApplicationMode: number;
		Area: number;
		BasePlanBook: Data.TaskManagement.IBasicFertilisationPlanBooks;
		CropType: number;
		DataSet: Data.Import.IDataSet;
		Ec: number;
		Factor: number;
		FarmId: number;
		FieldGeomId: System.IGuid;
		Id: System.IGuid;
		NContent: number;
		NContentAvg: number;
		NContentMax: number;
		NContentMin: number;
		NPlanBook: Data.TaskManagement.INFertilizationPlanBook;
		NUptake: number;
		NUptakeAvg: number;
		NUptakeMax: number;
		NUptakeMin: number;
		OperationMode: number;
		PlantProtectionPlanBook: Data.TaskManagement.IPlantProtectionPlanBook;
		RasterId: System.IGuid;
		Status: number;
		WorkingWidth: number;
	}
	interface ILogs {
		CollectionTime: Date;
		FarmId: number;
		Id: System.IGuid;
		Values: string;
		Version: number;
	}
	interface IOrthoPhoto {
		Date: Date;
		Farm_Id: number;
		FileName: string;
		Id: System.IGuid;
		LayerName: string;
		Type: number;
		Url: string;
	}
	interface ISensorFieldData {
		ApplNum: number;
		Avg: number;
		Created: Date;
		CropKey: number;
		CroptypeId: number;
		DataSetFieldMapId: System.IGuid;
		Ec: number;
		FieldGeomId: System.IGuid;
		Max: number;
		Min: number;
		NfPlanBookId: System.IGuid;
		NUptake: number;
		NUptakeAvg: number;
		NUptakeMax: number;
		NUptakeMin: number;
		PpPlanBookId: System.IGuid;
		ValidForCampaignYear: boolean;
	}
}
declare namespace Data.TaskManagement {
	export const enum NminPotentials {
		Low = 0,
		Medium = 1,
		High = 2
	}
	export const enum TaskManagementModule {
		GD_BasicFertilization = 0,
		N_NFertilization = 1,
		PS_Fertilization = 2
	}
	export const enum TaskManagementStatus {
		Red = -1,
		Yellow = 0,
		Green = 1
	}
	export const enum TaskManagementUnit {
		KiloGramPerHectare = 1,
		CubicMeterPerHectare = 2,
		TonsPerHectare = 3
	}
	interface IBasicFertilisationPlanBooks extends Data.Api.IBaseEntity {
		Appl_Const: number;
		Appl_Max: number;
		Appl_Min: number;
		Appl_Mode: Data.Common.IApplicationMode;
		Appl_Rate: number;
		ApplicationDate: Date;
		Area: number;
		AreaHa: number;
		BookedAt: Date;
		BookedBy: number;
		Croptype_Id: number;
		Croptype_Second_Id: number;
		Element: Data.Common.IElement;
		ExportDriver: System.IGuid;
		ExportedAt: Date;
		ExportedBy: number;
		ExportFormat: number;
		ExportInstrument: System.IGuid;
		ExportMachine: System.IGuid;
		ExportTarget: string;
		Factor: number;
		Field_Geom_Id: System.IGuid;
		FieldId: System.IGuid;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Id: System.IGuid;
		JobInput: string;
		Note: string;
		Operation_Mode: Data.Common.IOperationMode;
		Product_Id: number;
		Statistic: Data.TaskManagement.INutrientFertilisationPlanBooksStatisticValue[];
		Status: Data.TaskManagement.TaskManagementStatus;
		Summary_Id: System.IGuid;
		TEnd: System.ITimeSpan;
		TStart: System.ITimeSpan;
		Unit: Data.Common.IUnit;
		Valid_From: Date;
		Valid_To: Date;
	}
	interface IBasicFertilisationSummaries extends Data.Api.IBaseEntity {
		BasicFertilisationPlanBooks: Data.TaskManagement.IBasicFertilisationPlanBooks[];
		Id: System.IGuid;
		PlanNumber: number;
		Statistic: Data.TaskManagement.INutrientFertilisationStatisticValue[];
		Title: string;
		User_Appl_Const: number;
		User_Appl_Date: Date;
		User_Appl_Max: number;
		User_Appl_Min: number;
		User_Appl_Mode: Data.Common.IApplicationMode;
		User_Appl_Rate: number;
		User_Appl_Unit: Data.Common.IUnit;
		User_Operation_Mode: Data.Common.IOperationMode;
	}
	interface IIPlanBook {
		ApplicationDate: Date;
		BookedAt: Date;
		BookedBy: number;
		ChangedAt: Date;
		ChangedBy: number;
		DeletedAt: Date;
		DeletedBy: number;
		ExportDriver: System.IGuid;
		ExportedAt: Date;
		ExportedBy: number;
		ExportFormat: number;
		ExportInstrument: System.IGuid;
		ExportMachine: System.IGuid;
		ExportTarget: string;
		Id: System.IGuid;
		Status: Data.TaskManagement.TaskManagementStatus;
		Version: number;
	}
	interface INFertilizationAdditionalValues {
		DeadBiomass: number;
		ExpectedYield: number;
		NMinPotential: Data.TaskManagement.NminPotentials;
	}
	interface INFertilizationPlanBook extends Data.Api.IBaseEntity {
		ApplicationConst: number;
		ApplicationDate: Date;
		ApplicationMax: number;
		ApplicationMin: number;
		ApplicationMode: Data.Common.IApplicationMode;
		ApplicationRate: number;
		Area: number;
		BookedAt: Date;
		BookedBy: number;
		ECValue: number;
		Element: number;
		ExportDriver: System.IGuid;
		ExportedAt: Date;
		ExportedBy: number;
		ExportFormat: number;
		ExportInstrument: System.IGuid;
		ExportMachine: System.IGuid;
		ExportTarget: string;
		Factor: number;
		FieldGeomId: System.IGuid;
		FieldId: System.IGuid;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Id: System.IGuid;
		JobInput: string;
		LogFileOperationMode: number;
		MainCropId: number;
		Note: string;
		OperationMode: Data.Common.IOperationMode;
		PlannedArea: number;
		ProductId: number;
		RasterId: System.IGuid;
		RasterStatistics: Data.Nutrients.IFieldNutrientPlanningStatistic[];
		SecondCropId: number;
		Slope: number;
		Status: Data.TaskManagement.TaskManagementStatus;
		Summary: Data.TaskManagement.INFertilizationSummary;
		TEnd: System.ITimeSpan;
		Threshold: number;
		TStart: System.ITimeSpan;
		Unit: Data.Common.IUnit;
		ValidFrom: Date;
		ValidTo: Date;
	}
	interface INFertilizationSummary extends Data.Api.IBaseEntity {
		AdditionalValue: Data.TaskManagement.INFertilizationAdditionalValues;
		ApplicationDate: Date;
		ApplicationMode: Data.Common.IApplicationMode;
		ECValue: number;
		Id: System.IGuid;
		OperationMode: Data.Common.IOperationMode;
		PlanNumber: number;
		Slope: number;
		Threshold: number;
		Title: string;
		Unit: Data.Common.IUnit;
		UserApplicationConstant: number;
		UserApplicationMaximum: number;
		UserApplicationMinimum: number;
		UserApplicationRate: number;
	}
	interface INutrientFertilisationPlanBooksStatisticValue {
		Band: number;
		Cells: number;
		Duration: number;
		ErrorText: string;
		FieldGeomId: System.IGuid;
		FieldStatistic: Data.TaskManagement.IStatisticHistogram[];
		Id: number;
		Max: number;
		Mean: number;
		Median: number;
		Min: number;
		Most: number;
		PlanId: System.IGuid;
		RasterStatistic: Data.TaskManagement.IStatisticHistogram[];
		Sum: number;
	}
	interface INutrientFertilisationStatisticValue {
		Average: number;
		ElementId: number;
		Max: number;
		Min: number;
	}
	interface IPlantProtectionPlanAdditionalValues {
		ZeroRate: boolean;
	}
	interface IPlantProtectionPlanBook extends Data.Api.IBaseEntity {
		AdditionalValues: Data.TaskManagement.IPlantProtectionPlanAdditionalValues;
		ApplicationConst: number;
		ApplicationDate: Date;
		ApplicationMax: number;
		ApplicationMin: number;
		ApplicationMode: Data.Common.IApplicationMode;
		ApplicationRate: number;
		Area: number;
		BookedAt: Date;
		BookedBy: number;
		CampaignYear: number;
		EcValue: number;
		Element: number;
		ExportDriver: System.IGuid;
		ExportedAt: Date;
		ExportedBy: number;
		ExportFormat: number;
		ExportInstrument: System.IGuid;
		ExportMachine: System.IGuid;
		ExportTarget: string;
		Factor: number;
		FieldGeomId: System.IGuid;
		FieldId: System.IGuid;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Id: System.IGuid;
		JobInput: string;
		LogfileOperationMode: number;
		MainCropId: number;
		Note: string;
		OperationMode: Data.Common.IOperationMode;
		PlannedArea: number;
		ProductList: Data.TaskManagement.IPlantProtectionProductList[];
		RasterId: System.IGuid;
		RasterStatistics: Data.Nutrients.IFieldNutrientPlanningStatistic[];
		SecondCropId: number;
		Slope: number;
		Statistic: string;
		Status: Data.TaskManagement.TaskManagementStatus;
		Summary: Data.TaskManagement.IPlantProtectionSummary;
		TEnd: System.ITimeSpan;
		Threshold: number;
		TStart: System.ITimeSpan;
		Unit: Data.Common.IUnit;
		ValidFrom: Date;
		ValidTo: Date;
	}
	interface IPlantProtectionProductList {
		FarmId: number;
		Id: System.IGuid;
		PlanId: System.IGuid;
		Product: Data.BaseData.IPlantProtectionProduct;
		ProductListDetails: Data.TaskManagement.IPlantProtectionProductListDetails;
		ProductRate: number;
		Unit: Data.Common.IUnit;
	}
	interface IPlantProtectionProductListDetails {
		AmountMax: number;
		EcMax: number;
		EcMin: number;
		EffectiveRange: string;
		EppoCrop: string;
		EppoHarmfulOrganism: string;
		Id: System.IGuid;
		WorkType: number;
	}
	interface IPlantProtectionSummary extends Data.Api.IBaseEntity {
		AdditionalValue: Data.TaskManagement.IPlantProtectionPlanAdditionalValues;
		ApplicationDate: Date;
		ApplicationMode: Data.Common.IApplicationMode;
		EcValue: number;
		Id: System.IGuid;
		OperationMode: Data.Common.IOperationMode;
		PlanNumber: number;
		Slope: number;
		Threshold: number;
		Title: string;
		Unit: Data.Common.IUnit;
		UserApplicationConstant: number;
		UserApplicationMaximum: number;
		UserApplicationMinimum: number;
		UserApplicationRate: number;
	}
	interface IStatisticHistogram {
		Key: number;
		Value: number;
	}
	interface ITaskManagementPlanBook {
		ApplConst: number;
		ApplDate: Date;
		ApplicationMode: Data.Common.IApplicationMode;
		ApplMax: number;
		ApplMin: number;
		ApplRate: number;
		ApplUnit: Data.Common.IUnit;
		AreaHa: number;
		BookedAt: Date;
		BookedBy: number;
		ChangedAt: Date;
		CountryCode: string;
		CreatedAt: Date;
		DeadBioMass: number;
		ECValue: number;
		Element: Data.Common.IElement;
		ExpectedYield: number;
		ExportDriver: Data.DocuContext.Driver.IDriver;
		ExportedAt: Date;
		ExportedBy: number;
		ExportFormat: Data.Common.IExportFormat;
		ExportInstrument: Data.DocuContext.Instrument.IInstrument;
		ExportMachine: Data.DocuContext.Machine.IMachine;
		ExportTarget: string;
		Factor: number;
		FieldGeomId: System.IGuid;
		FieldId: System.IGuid;
		Geom: NetTopologySuite.Geometries.IGeometry;
		Id: System.IGuid;
		MainCropId: number;
		Module: Data.TaskManagement.TaskManagementModule;
		ModuleText: string;
		NMinPotential: Data.TaskManagement.NminPotentials;
		Note: string;
		OperationMode: Data.Common.IOperationMode;
		PlanNumber: number;
		Position: number;
		PpProductList: Data.TaskManagement.IPlantProtectionProductList[];
		ProductId: number;
		SecondCropId: number;
		Slope: number;
		SourcePlanBook: Data.TaskManagement.IIPlanBook;
		Status: Data.TaskManagement.TaskManagementStatus;
		Summary: Data.TaskManagement.INFertilizationSummary;
		Threshold: number;
		ValidFrom: Date;
		ValidTo: Date;
	}
	interface ITaskManagementPlanSummary {
		ApplDate: Date;
		ApplicationMode: Data.Common.IApplicationMode;
		ApplRate: number;
		ApplUnit: Data.Common.IUnit;
		AreaHa: number;
		Element: Data.Common.IElement;
		Id: System.IGuid;
		Module: Data.TaskManagement.TaskManagementModule;
		OperationMode: Data.Common.IOperationMode;
		PlanBooks: Data.TaskManagement.ITaskManagementPlanBook[];
		PlanNumber: number;
		ProductId: number;
		Remark: string;
		Statistic: Data.TaskManagement.INutrientFertilisationStatisticValue[];
		Status: Data.TaskManagement.TaskManagementStatus;
	}
}
declare namespace Data.Tracelog {
	interface IActions {
		ClientIp: string;
		Data: Invoker.IInvokeArgument[];
		DateTime: Date;
		Duration: number;
		FarmId: number;
		Id: System.IGuid;
		Message: string;
		TimeStamp: Date;
		UserId: number;
		Year: number;
	}
	interface IBackend {
		Arguments: string;
		Context: string;
		DateTime: Date;
		Id: System.IGuid;
		Level: string;
		Message: string;
		Timestamp: Date;
	}
	interface IClient {
		ClientIp: string;
		DateTime: Date;
		FarmId: number;
		Id: System.IGuid;
		Level: string;
		Message: string;
		Meta: string;
		StackTrace: string;
		State: string;
		Timestamp: Date;
	}
	interface IMissingFactors {
		Id: System.IGuid;
		Source: number;
		Target: number;
	}
	interface IMissingTranslations {
		CountryCode: string;
		Id: System.IGuid;
		LastUsed: Date;
		TranslationKey: string;
		UsedCount: number;
	}
	interface ITrialActivation {
		CreatedAt: Date;
		CreatedBy: number;
		FarmId: number;
		FeatureModul: Data.Licensing.IFeatureModul;
		Id: System.IGuid;
	}
}
declare namespace Data.UserType {
	interface ICacheInfo {
		Id: number;
		VersionsIndex: string;
	}
	interface ICacheModel {
		Id: number;
		Version: number;
	}
	interface IJsonbGenericUserType {
		IsMutable: boolean;
		ReturnedType: System.IType;
		SqlTypes: NHibernate.SqlTypes.ISqlType[];
	}
}
declare namespace Invoker {
	interface IInvokeArgument {
		Name: string;
		Type: string;
		Value: string;
	}
	interface IInvokeMessage {
		Arguments: Invoker.IInvokeArgument[];
		BrowserTabId: string;
		Context: string;
	}
	interface IResultMessage {
		Context: string;
		Data: any;
		Error: System.IException;
	}
	interface IUpdateResultMessage {
		Item: any;
		ModelName: string;
		Operation: Agriport.Invoker.Api.Database.DatabaseNotifyOperation;
		StoreName: string;
	}
}
declare namespace NetTopologySuite {
	interface INtsGeometryServices {
		CoordinateEqualityComparer: NetTopologySuite.Geometries.ICoordinateEqualityComparer;
		DefaultCoordinateSequenceFactory: NetTopologySuite.Geometries.ICoordinateSequenceFactory;
		DefaultPrecisionModel: NetTopologySuite.Geometries.IPrecisionModel;
		DefaultSRID: number;
		GeometryOverlay: NetTopologySuite.Geometries.IGeometryOverlay;
		Instance: NetTopologySuite.INtsGeometryServices;
	}
}
declare namespace NetTopologySuite.Geometries {
	export const enum Dimension {
		Point = 0,
		P = 0,
		Curve = 1,
		L = 1,
		Surface = 2,
		A = 2,
		False = -1,
		True = -2,
		Dontcare = -3,
		Unknown = -1,
		Collapse = 3
	}
	export const enum OgcGeometryType {
		Point = 1,
		LineString = 2,
		Polygon = 3,
		MultiPoint = 4,
		MultiLineString = 5,
		MultiPolygon = 6,
		GeometryCollection = 7,
		CircularString = 8,
		CompoundCurve = 9,
		CurvePolygon = 10,
		MultiCurve = 11,
		MultiSurface = 12,
		Curve = 13,
		Surface = 14,
		PolyhedralSurface = 15,
		TIN = 16
	}
	export const enum Ordinates {
		None = 0,
		X = 1,
		Y = 2,
		Z = 4,
		M = 65536,
		XY = 3,
		XYZ = 7,
		XYM = 65539,
		XYZM = 65543,
		Spatial1 = 1,
		Spatial2 = 2,
		Spatial3 = 4,
		Spatial4 = 8,
		Spatial5 = 16,
		Spatial6 = 32,
		Spatial7 = 64,
		Spatial8 = 128,
		Spatial9 = 256,
		Spatial10 = 512,
		Spatial11 = 1024,
		Spatial12 = 2048,
		Spatial13 = 4096,
		Spatial14 = 8192,
		Spatial15 = 16384,
		Spatial16 = 32768,
		AllSpatialOrdinates = 65535,
		Measure1 = 65536,
		Measure2 = 131072,
		Measure3 = 262144,
		Measure4 = 524288,
		Measure5 = 1048576,
		Measure6 = 2097152,
		Measure7 = 4194304,
		Measure8 = 8388608,
		Measure9 = 16777216,
		Measure10 = 33554432,
		Measure11 = 67108864,
		Measure12 = 134217728,
		Measure13 = 268435456,
		Measure14 = 536870912,
		Measure15 = 1073741824,
		Measure16 = -2147483648,
		AllMeasureOrdinates = -65536,
		AllOrdinates = -1
	}
	export const enum PrecisionModels {
		Floating = 0,
		FloatingSingle = 1,
		Fixed = 2
	}
	interface ICoordinate {
		CoordinateValue: NetTopologySuite.Geometries.ICoordinate;
		IsValid: boolean;
		Item_Int32ordinateIndex: number;
		Item_NetTopologySuiteGeometriesOrdinateordinate: number;
		M: number;
		X: number;
		Y: number;
		Z: number;
	}
	interface ICoordinateEqualityComparer extends System.Collections.Generic.IEqualityComparer {
	}
	interface ICoordinateSequence {
		Count: number;
		Dimension: number;
		First: NetTopologySuite.Geometries.ICoordinate;
		HasM: boolean;
		HasZ: boolean;
		Last: NetTopologySuite.Geometries.ICoordinate;
		Measures: number;
		MOrdinateIndex: number;
		Ordinates: NetTopologySuite.Geometries.Ordinates;
		Spatial: number;
		ZOrdinateIndex: number;
	}
	interface ICoordinateSequenceFactory {
		Ordinates: NetTopologySuite.Geometries.Ordinates;
	}
	interface IEnvelope {
		Area: number;
		Centre: NetTopologySuite.Geometries.ICoordinate;
		Diameter: number;
		Height: number;
		IsNull: boolean;
		MaxExtent: number;
		MaxX: number;
		MaxY: number;
		MinExtent: number;
		MinX: number;
		MinY: number;
		Width: number;
	}
	interface IGeometry {
		Area: number;
		Boundary: NetTopologySuite.Geometries.IGeometry;
		BoundaryDimension: NetTopologySuite.Geometries.Dimension;
		Centroid: NetTopologySuite.Geometries.IPoint;
		Coordinate: NetTopologySuite.Geometries.ICoordinate;
		Coordinates: NetTopologySuite.Geometries.ICoordinate[];
		Dimension: NetTopologySuite.Geometries.Dimension;
		Envelope: NetTopologySuite.Geometries.IGeometry;
		EnvelopeInternal: NetTopologySuite.Geometries.IEnvelope;
		Factory: NetTopologySuite.Geometries.IGeometryFactory;
		GeometryType: string;
		InteriorPoint: NetTopologySuite.Geometries.IPoint;
		IsEmpty: boolean;
		IsRectangle: boolean;
		IsSimple: boolean;
		IsValid: boolean;
		Length: number;
		NumGeometries: number;
		NumPoints: number;
		OgcGeometryType: NetTopologySuite.Geometries.OgcGeometryType;
		PointOnSurface: NetTopologySuite.Geometries.IPoint;
		PrecisionModel: NetTopologySuite.Geometries.IPrecisionModel;
		SRID: number;
		UserData: any;
	}
	interface IGeometryFactory {
		CoordinateSequenceFactory: NetTopologySuite.Geometries.ICoordinateSequenceFactory;
		GeometryServices: NetTopologySuite.INtsGeometryServices;
		PrecisionModel: NetTopologySuite.Geometries.IPrecisionModel;
		SRID: number;
	}
	interface IGeometryOverlay {
		Legacy: NetTopologySuite.Geometries.IGeometryOverlay;
		NG: NetTopologySuite.Geometries.IGeometryOverlay;
	}
	interface IPoint extends NetTopologySuite.Geometries.IGeometry {
		Boundary: NetTopologySuite.Geometries.IGeometry;
		BoundaryDimension: NetTopologySuite.Geometries.Dimension;
		Coordinate: NetTopologySuite.Geometries.ICoordinate;
		Coordinates: NetTopologySuite.Geometries.ICoordinate[];
		CoordinateSequence: NetTopologySuite.Geometries.ICoordinateSequence;
		Dimension: NetTopologySuite.Geometries.Dimension;
		GeometryType: string;
		IsEmpty: boolean;
		M: number;
		NumPoints: number;
		OgcGeometryType: NetTopologySuite.Geometries.OgcGeometryType;
		X: number;
		Y: number;
		Z: number;
	}
	interface IPrecisionModel {
		Fixed: System.ILazy;
		Floating: System.ILazy;
		FloatingSingle: System.ILazy;
		GridSize: number;
		IsFloating: boolean;
		MaximumSignificantDigits: number;
		PrecisionModelType: NetTopologySuite.Geometries.PrecisionModels;
		Scale: number;
	}
}
declare namespace NHibernate.SqlTypes {
	interface ISqlType {
		DbType: System.Data.DbType;
		Length: number;
		LengthDefined: boolean;
		Precision: number;
		PrecisionDefined: boolean;
		Scale: number;
		ScaleDefined: boolean;
	}
}
declare namespace System {
	interface IAttribute {
		TypeId: any;
	}
	interface IException {
		Data: any;
		HelpLink: string;
		HResult: number;
		InnerException: System.IException;
		Message: string;
		Source: string;
		StackTrace: string;
		TargetSite: System.Reflection.IMethodBase;
	}
	interface IGuid {
	}
	interface ILazy {
		IsValueCreated: boolean;
		Value: any;
	}
	interface IModuleHandle {
		MDStreamVersion: number;
	}
	interface IRuntimeFieldHandle {
		Value: number;
	}
	interface IRuntimeMethodHandle {
		Value: number;
	}
	interface IRuntimeTypeHandle {
		Value: number;
	}
	interface ITimeSpan {
		Days: number;
		Hours: number;
		Microseconds: number;
		Milliseconds: number;
		Minutes: number;
		Nanoseconds: number;
		Seconds: number;
		Ticks: number;
		TotalDays: number;
		TotalHours: number;
		TotalMicroseconds: number;
		TotalMilliseconds: number;
		TotalMinutes: number;
		TotalNanoseconds: number;
		TotalSeconds: number;
	}
	interface IType extends System.Reflection.IMemberInfo {
		Assembly: System.Reflection.IAssembly;
		AssemblyQualifiedName: string;
		Attributes: System.Reflection.TypeAttributes;
		BaseType: System.IType;
		ContainsGenericParameters: boolean;
		DeclaringMethod: System.Reflection.IMethodBase;
		DeclaringType: System.IType;
		DefaultBinder: System.Reflection.IBinder;
		FullName: string;
		GenericParameterAttributes: System.Reflection.GenericParameterAttributes;
		GenericParameterPosition: number;
		GenericTypeArguments: System.IType[];
		GUID: System.IGuid;
		HasElementType: boolean;
		IsAbstract: boolean;
		IsAnsiClass: boolean;
		IsArray: boolean;
		IsAutoClass: boolean;
		IsAutoLayout: boolean;
		IsByRef: boolean;
		IsByRefLike: boolean;
		IsClass: boolean;
		IsCOMObject: boolean;
		IsConstructedGenericType: boolean;
		IsContextful: boolean;
		IsEnum: boolean;
		IsExplicitLayout: boolean;
		IsFunctionPointer: boolean;
		IsGenericMethodParameter: boolean;
		IsGenericParameter: boolean;
		IsGenericType: boolean;
		IsGenericTypeDefinition: boolean;
		IsGenericTypeParameter: boolean;
		IsImport: boolean;
		IsInterface: boolean;
		IsLayoutSequential: boolean;
		IsMarshalByRef: boolean;
		IsNested: boolean;
		IsNestedAssembly: boolean;
		IsNestedFamANDAssem: boolean;
		IsNestedFamily: boolean;
		IsNestedFamORAssem: boolean;
		IsNestedPrivate: boolean;
		IsNestedPublic: boolean;
		IsNotPublic: boolean;
		IsPointer: boolean;
		IsPrimitive: boolean;
		IsPublic: boolean;
		IsSealed: boolean;
		IsSecurityCritical: boolean;
		IsSecuritySafeCritical: boolean;
		IsSecurityTransparent: boolean;
		IsSerializable: boolean;
		IsSignatureType: boolean;
		IsSpecialName: boolean;
		IsSZArray: boolean;
		IsTypeDefinition: boolean;
		IsUnicodeClass: boolean;
		IsUnmanagedFunctionPointer: boolean;
		IsValueType: boolean;
		IsVariableBoundArray: boolean;
		IsVisible: boolean;
		MemberType: System.Reflection.MemberTypes;
		Module: System.Reflection.IModule;
		Namespace: string;
		ReflectedType: System.IType;
		StructLayoutAttribute: System.Runtime.InteropServices.IStructLayoutAttribute;
		TypeHandle: System.IRuntimeTypeHandle;
		TypeInitializer: System.Reflection.IConstructorInfo;
		UnderlyingSystemType: System.IType;
	}
}
declare namespace System.Collections.Generic {
	interface IEqualityComparer {
		Default: System.Collections.Generic.IEqualityComparer;
	}
	interface IKeyValuePair {
		Key: any;
		Value: any;
	}
}
declare namespace System.Data {
	export const enum DbType {
		AnsiString = 0,
		Binary = 1,
		Byte = 2,
		Boolean = 3,
		Currency = 4,
		Date = 5,
		DateTime = 6,
		Decimal = 7,
		Double = 8,
		Guid = 9,
		Int16 = 10,
		Int32 = 11,
		Int64 = 12,
		Object = 13,
		SByte = 14,
		Single = 15,
		String = 16,
		Time = 17,
		UInt16 = 18,
		UInt32 = 19,
		UInt64 = 20,
		VarNumeric = 21,
		AnsiStringFixedLength = 22,
		StringFixedLength = 23,
		Xml = 25,
		DateTime2 = 26,
		DateTimeOffset = 27
	}
}
declare namespace System.Reflection {
	export const enum CallingConventions {
		Standard = 1,
		VarArgs = 2,
		Any = 3,
		HasThis = 32,
		ExplicitThis = 64
	}
	export const enum EventAttributes {
		None = 0,
		SpecialName = 512,
		RTSpecialName = 1024,
		ReservedMask = 1024
	}
	export const enum FieldAttributes {
		FieldAccessMask = 7,
		PrivateScope = 0,
		Private = 1,
		FamANDAssem = 2,
		Assembly = 3,
		Family = 4,
		FamORAssem = 5,
		Public = 6,
		Static = 16,
		InitOnly = 32,
		Literal = 64,
		NotSerialized = 128,
		SpecialName = 512,
		PinvokeImpl = 8192,
		RTSpecialName = 1024,
		HasFieldMarshal = 4096,
		HasDefault = 32768,
		HasFieldRVA = 256,
		ReservedMask = 38144
	}
	export const enum GenericParameterAttributes {
		None = 0,
		VarianceMask = 3,
		Covariant = 1,
		Contravariant = 2,
		SpecialConstraintMask = 28,
		ReferenceTypeConstraint = 4,
		NotNullableValueTypeConstraint = 8,
		DefaultConstructorConstraint = 16
	}
	export const enum MemberTypes {
		Constructor = 1,
		Event = 2,
		Field = 4,
		Method = 8,
		Property = 16,
		TypeInfo = 32,
		Custom = 64,
		NestedType = 128,
		All = 191
	}
	export const enum MethodAttributes {
		MemberAccessMask = 7,
		PrivateScope = 0,
		Private = 1,
		FamANDAssem = 2,
		Assembly = 3,
		Family = 4,
		FamORAssem = 5,
		Public = 6,
		Static = 16,
		Final = 32,
		Virtual = 64,
		HideBySig = 128,
		CheckAccessOnOverride = 512,
		VtableLayoutMask = 256,
		ReuseSlot = 0,
		NewSlot = 256,
		Abstract = 1024,
		SpecialName = 2048,
		PinvokeImpl = 8192,
		UnmanagedExport = 8,
		RTSpecialName = 4096,
		HasSecurity = 16384,
		RequireSecObject = 32768,
		ReservedMask = 53248
	}
	export const enum MethodImplAttributes {
		CodeTypeMask = 3,
		IL = 0,
		Native = 1,
		OPTIL = 2,
		Runtime = 3,
		ManagedMask = 4,
		Unmanaged = 4,
		Managed = 0,
		ForwardRef = 16,
		PreserveSig = 128,
		InternalCall = 4096,
		Synchronized = 32,
		NoInlining = 8,
		AggressiveInlining = 256,
		NoOptimization = 64,
		AggressiveOptimization = 512,
		MaxMethodImplVal = 65535
	}
	export const enum ParameterAttributes {
		None = 0,
		In = 1,
		Out = 2,
		Lcid = 4,
		Retval = 8,
		Optional = 16,
		HasDefault = 4096,
		HasFieldMarshal = 8192,
		Reserved3 = 16384,
		Reserved4 = 32768,
		ReservedMask = 61440
	}
	export const enum PropertyAttributes {
		None = 0,
		SpecialName = 512,
		RTSpecialName = 1024,
		HasDefault = 4096,
		Reserved2 = 8192,
		Reserved3 = 16384,
		Reserved4 = 32768,
		ReservedMask = 62464
	}
	export const enum TypeAttributes {
		VisibilityMask = 7,
		NotPublic = 0,
		Public = 1,
		NestedPublic = 2,
		NestedPrivate = 3,
		NestedFamily = 4,
		NestedAssembly = 5,
		NestedFamANDAssem = 6,
		NestedFamORAssem = 7,
		LayoutMask = 24,
		AutoLayout = 0,
		SequentialLayout = 8,
		ExplicitLayout = 16,
		ClassSemanticsMask = 32,
		Class = 0,
		Interface = 32,
		Abstract = 128,
		Sealed = 256,
		SpecialName = 1024,
		Import = 4096,
		Serializable = 8192,
		WindowsRuntime = 16384,
		StringFormatMask = 196608,
		AnsiClass = 0,
		UnicodeClass = 65536,
		AutoClass = 131072,
		CustomFormatClass = 196608,
		CustomFormatMask = 12582912,
		BeforeFieldInit = 1048576,
		RTSpecialName = 2048,
		HasSecurity = 262144,
		ReservedMask = 264192
	}
	interface IAssembly {
		CodeBase: string;
		CustomAttributes: System.Reflection.ICustomAttributeData[];
		DefinedTypes: System.Reflection.ITypeInfo[];
		EntryPoint: System.Reflection.IMethodInfo;
		EscapedCodeBase: string;
		ExportedTypes: System.IType[];
		FullName: string;
		GlobalAssemblyCache: boolean;
		HostContext: number;
		ImageRuntimeVersion: string;
		IsCollectible: boolean;
		IsDynamic: boolean;
		IsFullyTrusted: boolean;
		Location: string;
		ManifestModule: System.Reflection.IModule;
		Modules: System.Reflection.IModule[];
		ReflectionOnly: boolean;
		SecurityRuleSet: System.Security.SecurityRuleSet;
	}
	interface IBinder {
	}
	interface IConstructorInfo extends System.Reflection.IMethodBase {
		MemberType: System.Reflection.MemberTypes;
	}
	interface ICustomAttributeData {
		AttributeType: System.IType;
		Constructor: System.Reflection.IConstructorInfo;
		ConstructorArguments: System.Reflection.ICustomAttributeTypedArgument[];
		NamedArguments: System.Reflection.ICustomAttributeNamedArgument[];
	}
	interface ICustomAttributeNamedArgument {
		IsField: boolean;
		MemberInfo: System.Reflection.IMemberInfo;
		MemberName: string;
		TypedValue: System.Reflection.ICustomAttributeTypedArgument;
	}
	interface ICustomAttributeTypedArgument {
		ArgumentType: System.IType;
		Value: any;
	}
	interface IEventInfo extends System.Reflection.IMemberInfo {
		AddMethod: System.Reflection.IMethodInfo;
		Attributes: System.Reflection.EventAttributes;
		EventHandlerType: System.IType;
		IsMulticast: boolean;
		IsSpecialName: boolean;
		MemberType: System.Reflection.MemberTypes;
		RaiseMethod: System.Reflection.IMethodInfo;
		RemoveMethod: System.Reflection.IMethodInfo;
	}
	interface IFieldInfo extends System.Reflection.IMemberInfo {
		Attributes: System.Reflection.FieldAttributes;
		FieldHandle: System.IRuntimeFieldHandle;
		FieldType: System.IType;
		IsAssembly: boolean;
		IsFamily: boolean;
		IsFamilyAndAssembly: boolean;
		IsFamilyOrAssembly: boolean;
		IsInitOnly: boolean;
		IsLiteral: boolean;
		IsNotSerialized: boolean;
		IsPinvokeImpl: boolean;
		IsPrivate: boolean;
		IsPublic: boolean;
		IsSecurityCritical: boolean;
		IsSecuritySafeCritical: boolean;
		IsSecurityTransparent: boolean;
		IsSpecialName: boolean;
		IsStatic: boolean;
		MemberType: System.Reflection.MemberTypes;
	}
	interface IICustomAttributeProvider {
	}
	interface IMemberInfo {
		CustomAttributes: System.Reflection.ICustomAttributeData[];
		DeclaringType: System.IType;
		IsCollectible: boolean;
		MemberType: System.Reflection.MemberTypes;
		MetadataToken: number;
		Module: System.Reflection.IModule;
		Name: string;
		ReflectedType: System.IType;
	}
	interface IMethodBase extends System.Reflection.IMemberInfo {
		Attributes: System.Reflection.MethodAttributes;
		CallingConvention: System.Reflection.CallingConventions;
		ContainsGenericParameters: boolean;
		IsAbstract: boolean;
		IsAssembly: boolean;
		IsConstructedGenericMethod: boolean;
		IsConstructor: boolean;
		IsFamily: boolean;
		IsFamilyAndAssembly: boolean;
		IsFamilyOrAssembly: boolean;
		IsFinal: boolean;
		IsGenericMethod: boolean;
		IsGenericMethodDefinition: boolean;
		IsHideBySig: boolean;
		IsPrivate: boolean;
		IsPublic: boolean;
		IsSecurityCritical: boolean;
		IsSecuritySafeCritical: boolean;
		IsSecurityTransparent: boolean;
		IsSpecialName: boolean;
		IsStatic: boolean;
		IsVirtual: boolean;
		MethodHandle: System.IRuntimeMethodHandle;
		MethodImplementationFlags: System.Reflection.MethodImplAttributes;
	}
	interface IMethodInfo extends System.Reflection.IMethodBase {
		MemberType: System.Reflection.MemberTypes;
		ReturnParameter: System.Reflection.IParameterInfo;
		ReturnType: System.IType;
		ReturnTypeCustomAttributes: System.Reflection.IICustomAttributeProvider;
	}
	interface IModule {
		Assembly: System.Reflection.IAssembly;
		CustomAttributes: System.Reflection.ICustomAttributeData[];
		FullyQualifiedName: string;
		MDStreamVersion: number;
		MetadataToken: number;
		ModuleHandle: System.IModuleHandle;
		ModuleVersionId: System.IGuid;
		Name: string;
		ScopeName: string;
	}
	interface IParameterInfo {
		Attributes: System.Reflection.ParameterAttributes;
		CustomAttributes: System.Reflection.ICustomAttributeData[];
		DefaultValue: any;
		HasDefaultValue: boolean;
		IsIn: boolean;
		IsLcid: boolean;
		IsOptional: boolean;
		IsOut: boolean;
		IsRetval: boolean;
		Member: System.Reflection.IMemberInfo;
		MetadataToken: number;
		Name: string;
		ParameterType: System.IType;
		Position: number;
		RawDefaultValue: any;
	}
	interface IPropertyInfo extends System.Reflection.IMemberInfo {
		Attributes: System.Reflection.PropertyAttributes;
		CanRead: boolean;
		CanWrite: boolean;
		GetMethod: System.Reflection.IMethodInfo;
		IsSpecialName: boolean;
		MemberType: System.Reflection.MemberTypes;
		PropertyType: System.IType;
		SetMethod: System.Reflection.IMethodInfo;
	}
	interface ITypeInfo extends System.IType {
		DeclaredConstructors: System.Reflection.IConstructorInfo[];
		DeclaredEvents: System.Reflection.IEventInfo[];
		DeclaredFields: System.Reflection.IFieldInfo[];
		DeclaredMembers: System.Reflection.IMemberInfo[];
		DeclaredMethods: System.Reflection.IMethodInfo[];
		DeclaredNestedTypes: System.Reflection.ITypeInfo[];
		DeclaredProperties: System.Reflection.IPropertyInfo[];
		GenericTypeParameters: System.IType[];
		ImplementedInterfaces: System.IType[];
	}
}
declare namespace System.Runtime.InteropServices {
	export const enum LayoutKind {
		Sequential = 0,
		Explicit = 2,
		Auto = 3
	}
	interface IStructLayoutAttribute extends System.IAttribute {
		Value: System.Runtime.InteropServices.LayoutKind;
	}
}
declare namespace System.Security {
	export const enum SecurityRuleSet {
		None = 0,
		Level1 = 1,
		Level2 = 2
	}
}
